// AUTO-GENERATED static English translations (hardcoded, no runtime LLM).
// Source: all t() strings + data-array UI copy, translated once. Regenerate via /tmp/gen_en.py + /tmp/translate_missing.py.
/* eslint-disable */
export const EN_GENERATED = {
  " + auto.merk : ": "+ car.make :",
  " + auto.model : ": "+ car.model :",
  " + model : ": "+ model :",
  " Bedrijfslogo op factuur": "Company logo on invoice",
  "\"Past op\"-check werkt nu ook met aftermarket-merken (Ridex, Febi, Bosch…) via OEM cross-reference": "\"Fits on\" check now also works with aftermarket brands (Ridex, Febi, Bosch…) via OEM cross-reference",
  "(KvK, BTW, IBAN voor op de factuur)": "(CoC, VAT, IBAN for the invoice)",
  "(eigen lijst actief)": "(custom list active)",
  "(geen normaal wachtwoord). Vereist 2FA op je Google account.": "(no regular password). Requires 2FA on your Google account.",
  "(geen omschrijving)": "(no description)",
  "(meestal dezelfde dag).": "(usually same day).",
  "(standaardlijst actief)": "(default list active)",
  "(straat + huisnr — klik 🔍 om plaats/postcode op te zoeken)": "(street + house no. — click 🔍 to look up city/postcode)",
  "(wordt vastgelegd in het logboek)": "(will be recorded in the logbook)",
  "(🔍 vult straat/plaats automatisch)": "(🔍 automatically fills street/city)",
  ", aantal: 1, prijs: 0, type, markering: ": ", quantity: 1, price: 0, type, marking:",
  ", kenteken: ": ", license plate:",
  ", merk: ": ", make:",
  ", model: ": ", model:",
  ", voorraad: 0, minVoorraad: 0, inkoop: 0, verkoop: 0, locatie: ": ", stock: 0, minStock: 0, purchase: 0, sale: 0, location:",
  "-- Kies een bon --": "-- Choose a receipt --",
  "0 auto": "0 car",
  "0 auto 16px": "0 auto 16px",
  "0,00": "0.00",
  "1. Download back-up": "1. Download backup",
  "1. Toepasselijkheid": "1. Applicability",
  "1. Wie zijn wij?": "1. Who are we?",
  "10. AI-functionaliteiten": "10. AI functionalities",
  "10. Wijzigingen": "10. Changes",
  "11. Externe gegevensbronnen": "11. External data sources",
  "12. Beschikbaarheid": "12. Availability",
  "13. Intellectueel eigendom": "13. Intellectual property",
  "14. Verboden gebruik": "14. Prohibited use",
  "15. Vrijwaring": "15. Indemnification",
  "16. Aansprakelijkheid": "16. Liability",
  "17. Overmacht": "17. Force majeure",
  "18. Beëindiging": "18. Termination",
  "19. Wijzigingen": "19. Changes",
  "1fr 1fr 1fr auto": "1fr 1fr 1fr auto",
  "1fr 1fr auto": "1fr 1fr auto",
  "2. Back-up herstellen (import)": "2. Restore backup (import)",
  "2. Definities": "2. Definitions",
  "2. Rolverdeling (verwerker vs. verwerkingsverantwoordelijke)": "2. Role distribution (processor vs. controller)",
  "20. Toepasselijk recht": "20. Applicable law",
  "21. Contact": "21. Contact",
  "24/7 uren tonen": "Show 24/7 hours",
  "3. Back-up naar cloud (Pro/Enterprise)": "3. Backup to cloud (Pro/Enterprise)",
  "3. Beschrijving van de dienst": "3. Description of the service",
  "3. Welke gegevens verwerken we?": "3. What data do we process?",
  "30 bonnen per maand": "30 receipts per month",
  "4. Account en toegang": "4. Account and access",
  "4. Doeleinden en grondslag": "4. Purposes and legal basis",
  "40px auto": "40px auto",
  "5. Licenties": "5. Licenses",
  "5. Verstrekking aan derden (sub-verwerkers)": "5. Provision to third parties (sub-processors)",
  "6. Bewaartermijnen": "6. Retention periods",
  "6. Proefversies en gratis pakketten": "6. Trial versions and free plans",
  "7. Beveiliging": "7. Security",
  "7. Prijzen en betaling": "7. Prices and payment",
  "8. Gegevens en eigendom": "8. Data and ownership",
  "8. Jouw rechten": "8. Your rights",
  "9. Back-ups": "9. Backups",
  "9. Cookies": "9. Cookies",
  "A license is tied to your garage upon activation - reuse by another garage is blocked.": "A license is tied to your garage upon activation - reuse by another garage is blocked.",
  "AI / Gemini API-sleutel": "AI / Gemini API key",
  "AI Advertentie-generator": "AI Ad Generator",
  "AI Advertentiemaker Pro": "AI Ad Maker Pro",
  "AI Diagnose": "AI Diagnostics",
  "AI Diagnose met controle": "AI Diagnosis with verification",
  "AI Diagnose werkt nu in 2 stappen: AI stelt voor → jij controleert → daarna pas opslaan": "AI Diagnosis now works in 2 steps: AI suggests → you verify → then save",
  "AI Foutcode-uitleg": "AI Error code explanation",
  "AI Offerte-assistent": "AI Quote Assistant",
  "AI Onderdeel-advertentie": "AI Part Ad",
  "AI advertentie": "AI Ad",
  "AI analyseert het diagnoserapport...": "AI is analyzing the diagnosis report...",
  "AI analyseert het rapport...": "AI is analyzing the report...",
  "AI analyseert je foto's direct mee voor opties, schade en waardebepaling.": "AI instantly analyzes your photos for options, damage, and valuation.",
  "AI analyseert je foto\\'s direct mee voor opties, schade en waardebepaling.": "AI directly analyzes your photos for options, damage, and valuation.",
  "AI analyseert…": "AI is analyzing...",
  "AI bepaalt nieuwprijs, gebruikte marktwaarde en sloopwaarde": "AI determines new price, used market value, and scrap value",
  "AI heeft de gegevens uitgelezen. Controleer en pas waar nodig aan — er wordt nog niets opgeslagen.": "AI has extracted the data. Please review and adjust as needed — nothing has been saved yet.",
  "AI leest de autopapieren…": "AI is reading the vehicle documents...",
  "AI leest je diagnoserapport voor je uit": "AI interprets your diagnostic report for you",
  "AI leest merk, model, bouwjaar, VIN, brandstof en voertuigtype automatisch in": "AI automatically reads make, model, year, VIN, fuel type, and vehicle type",
  "AI prijsadvies": "AI Pricing Advice",
  "AI prijsadvies-badge: zie in één oogopslag of je vraagprijs onder, op of boven de marktprijs ligt (incl. adviesvraagprijs)": "AI price advice badge: see at a glance if your asking price is below, at, or above market price (incl. recommended asking price)",
  "AI schrijft je advertentie…": "AI is writing your ad...",
  "AI stelt offerte op…": "AI is creating the quote...",
  "AI taxeert…": "AI is appraising...",
  "AI vertaal": "AI Translate",
  "AI vertalen": "AI Translate",
  "AI werkt de advertentie bij…": "AI is updating the ad...",
  "AI zoekt onderdelen…": "AI is searching for parts...",
  "AI-advertentie": "AI Ad",
  "AI-advertentie voor onderdelen": "AI-generated advertisement for parts",
  "AI-check mislukt": "AI Check Failed",
  "AI-fotoanalyse": "AI Photo Analysis",
  "AI-fotoanalyse: herkent staat, schade en kenmerken van het onderdeel": "AI photo analysis: recognizes condition, damage, and characteristics of the part",
  "AI-functionaliteiten worden uitsluitend aangeboden als hulpmiddel. MonteurCentraal geeft geen garantie over juistheid, volledigheid, actualiteit, geschiktheid of betrouwbaarheid.": "AI functionalities are provided solely as a tool. MonteurCentraal makes no guarantees regarding accuracy, completeness, timeliness, suitability, or reliability.",
  "AI-functionaliteiten:": "AI Functionalities:",
  "AI-suggesties": "AI Suggestions",
  "AI: herken onderdeel uit foto's": "AI: recognize part from photos",
  "AI: herken onderdeel uit foto\\'s": "AI: Identify Part from Photos",
  "AI: waar past dit nog meer op?": "AI: What else does this fit?",
  "APK": "MOT",
  "APK & Onderhoud": "MOT & Maintenance",
  "APK binnen 30 dagen": "MOT Due in 30 Days",
  "APK verlopen": "MOT Expired",
  "APK vervalt": "MOT Expires",
  "APK vervalt:": "MOT Expires:",
  "APK vrijgesteld": "MOT Exempt",
  "APK, openstaande betalingen en slapende klanten": "MOT, outstanding payments, and dormant customers",
  "APK-herinnering verstuurd": "MOT Reminder Sent",
  "APK-vervaldatums": "MOT Expiry Dates",
  "APK-voorkeuring": "Pre-MOT Inspection",
  "APK-voorkeuring checklist": "Pre-MOT Inspection Checklist",
  "APK-voorkeuring checklist (14 controlepunten) — afdrukbaar voor de klant": "MOT pre-inspection checklist (14 control points) — printable for the customer",
  "Aan": "On",
  "Aanbetaling": "Deposit",
  "Aanbetaling (€)": "Deposit (€)",
  "Aanbevolen onderhoud": "Recommended Maintenance",
  "Aanbevolen werkzaamheden": "Recommended Services",
  "Aandeel omzet": "Revenue Share",
  "Aangemaakt": "Created",
  "Aangemaakt via diagnose": "Created via Diagnosis",
  "Aangepast": "Modified",
  "Aantal": "Quantity",
  "Aantal artikelen": "Number of Items",
  "Aantal monteurs/bruggen dat tegelijk kan werken.": "Number of mechanics/bays that can work simultaneously.",
  "Aantal sleutels": "Number of Keys",
  "Accentkleur": "Accent Color",
  "Account": "Account",
  "Account aangemaakt! Check je e-mail om te activeren.": "Account created! Check your email to activate.",
  "Account aangemaakt, maar mail kon niet verstuurd worden. Probeer \"Opnieuw versturen\".": "Account created, but email could not be sent. Try \"Resend\".",
  "Account aanmaken": "Create Account",
  "Account activeren...": "Activating Account...",
  "Account succesvol geactiveerd! Welkom bij MonteurCentraal.": "Account successfully activated! Welcome to MonteurCentraal.",
  "Account:": "Account:",
  "Accountgegevens garage:": "Garage Account Details:",
  "Actie": "Action",
  "Actiecentrum — wat moet er vandaag gebeuren?": "Action Center — what needs to be done today?",
  "Actief": "Active",
  "Actief plan met": "Active plan with",
  "Acties: betaling toevoegen, refund, betaling verwijderen, document openen": "Actions: add payment, refund, delete payment, open document",
  "Actieve apparaten": "Active Devices",
  "Activa (bezittingen)": "Assets",
  "Activa en passiva op basis van je grootboek": "Assets and liabilities based on your general ledger",
  "Activa en passiva op basis van je grootboek. Activa = Passiva + Resultaat.": "Assets and liabilities based on your general ledger. Assets = Liabilities + Result.",
  "Activate a license via Settings → Plans.": "Activate a license via Settings → Plans.",
  "Activatie mislukt": "Activation failed",
  "Activatie mislukt. Vraag een nieuwe activatiemail aan.": "Activation failed. Request a new activation email.",
  "Activatielogboek": "Activation Log",
  "Activatielogboek / apparaten": "Activation Log / Devices",
  "Activeer een licentie via Instellingen → Plannen.": "Activate a license via Settings → Plans.",
  "Activeer eerst een licentie om cloud te koppelen.": "First activate a license to connect to cloud.",
  "Activeren": "Activate",
  "Add lines via the buttons above.": "Add lines via the buttons above.",
  "Add your garage details in": "Add your garage details in",
  "Admin-sleutel": "Admin Key",
  "Adres": "Address",
  "Adres (straat + huisnummer)": "Address (street + house number)",
  "Adres gevonden: ": "Address found:",
  "Adres ingevuld": "Address entered",
  "Adres lookup mislukt": "Address lookup failed",
  "Adres niet gevonden": "Address not found",
  "Adres opzoeken": "Look up address",
  "Adres opzoeken via PDOK (postcode + huisnr)": "Look up address via PDOK (postcode + house no.)",
  "Adres opzoeken via PDOK (straat + huisnr + plaats)": "Look up address via PDOK (street + house no. + city)",
  "Advertentie": "Ad",
  "Advertentie maken": "Create Ad",
  "Advertentie maken (AI)": "Create Ad (AI)",
  "Advertentie maken (AI) direct vanuit de onderdeelkaart, zonder eerst op te slaan en opnieuw te openen": "Create advertisement (AI) directly from the part card, without saving first and reopening",
  "Advertentietekst": "Ad text",
  "Advertentietekst in opmerkingen gezet": "Ad text added to comments",
  "Advies": "Advice",
  "Advies-vraagprijs": "Recommended asking price",
  "Adviesprijs overgenomen": "Recommended price adopted",
  "Adviesvraagprijs": "Recommended asking price",
  "Afdrukken": "Print",
  "Afdrukken / Opslaan als PDF": "Print / Save as PDF",
  "Afgedrukt via MonteurCentraal": "Printed via MonteurCentraal",
  "Afgeletterd": "Reconciled",
  "Afgewezen door klant": "Rejected by customer",
  "Afkomstig van": "Originating from",
  "Afkomstig van voertuig": "Originating from vehicle",
  "Afmelden": "Log out",
  "Afschrift uploaden": "Upload statement",
  "Afspraak": "Appointment",
  "Afspraak aanvragen": "Request appointment",
  "Afspraak bewerken": "Edit Appointment",
  "Afspraak maken": "Create Appointment",
  "Afspraak opgeslagen": "Appointment saved",
  "Afspraak verplaatst": "Appointment moved",
  "Afspraak verwijderd": "Appointment deleted",
  "Afspraak verwijderen?": "Delete appointment?",
  "Afspraakgegevens:": "Appointment details:",
  "Afspraken en werkagenda": "Appointments and work schedule",
  "Afspraken vandaag": "Appointments today",
  "After payment, you will receive a cryptographically signed license key via email.": "After payment, you will receive a cryptographically signed license key via email.",
  "Afzendernaam (optioneel)": "Sender name (optional)",
  "Akkoord": "Agree",
  "Akkoord & ondertekenen": "Agree & sign",
  "Akkoord geven": "Give approval",
  "Akkoord-link aangemaakt": "Approval link created",
  "Akkoord-link aanmaken": "Create approval link",
  "Al up-to-date": "Already up-to-date",
  "Albanië": "Albania",
  "Algemene Voorwaarden MonteurCentraal": "MonteurCentraal Terms and Conditions",
  "Algemene instellingen": "General settings",
  "Algemene instellingen opgeslagen": "General settings saved",
  "Algemene opmerkingen inname": "General intake comments",
  "Algemene voorwaarden": "Terms and conditions",
  "All confirmations, reminders and invoices sent via the app.": "All confirmations, reminders and invoices sent via the app.",
  "All confirmations, reminders, and invoices sent via the app.": "All confirmations, reminders, and invoices sent via the app.",
  "Alle": "All",
  "Alle AI-functies (advertenties, foutcode-uitleg, offerte-assistent, foto-herkenning, taxatie, compatibiliteit, papieren scannen en diagnoserapporten) draaien op jouw eigen, gratis Google Gemini-sleutel — je betaalt zelf niets extra en alles blijft binnen je eigen Google-account.": "All AI functions (ads, fault code explanation, quote assistant, photo recognition, appraisal, compatibility, document scanning, and diagnostic reports) run on your own, free Google Gemini key — you pay nothing extra and everything stays within your own Google account.",
  "Alle automatische journaalposten verwijderen en opnieuw opbouwen?": "Delete all automatic journal entries and rebuild them?",
  "Alle betalingen": "All payments",
  "Alle bevestigingen, herinneringen en facturen die via de app zijn verstuurd.": "All confirmations, reminders, and invoices sent via the app.",
  "Alle bruggen": "All lifts",
  "Alle categorieën": "All categories",
  "Alle door AI gegenereerde gegevens dienen altijd door de gebruiker te worden gecontroleerd voordat deze worden gebruikt. Gebruik van AI-functionaliteiten geschiedt volledig op eigen risico.": "All AI-generated data must always be verified by the user before use. Use of AI functionalities is entirely at your own risk.",
  "Alle gegevens die door de klant worden ingevoerd blijven eigendom van de klant. MonteurCentraal verkrijgt geen eigendomsrechten op klantgegevens.": "All data entered by the customer remains the property of the customer. MonteurCentraal does not acquire ownership rights to customer data.",
  "Alle intellectuele eigendomsrechten met betrekking tot software, broncode, ontwerpen, databases, documentatie, logo’s en handelsnamen blijven eigendom van MonteurCentraal.": "All intellectual property rights related to software, source code, designs, databases, documentation, logos, and trade names remain the property of MonteurCentraal.",
  "Alle keys zijn al vertaald": "All keys are already translated",
  "Alle medewerkers binnen": "All employees in",
  "Alle merken": "All brands",
  "Alle monteurs": "All mechanics",
  "Alle seizoenen": "All seasons",
  "Alle statussen": "All statuses",
  "Alle toekomstige updates inbegrepen": "All future updates included",
  "Alle voorraad is op peil.": "All stock is at the required level.",
  "Alleen .json bestanden": "Only .json files",
  "Alleen PDF-bestanden": "Only PDF files",
  "Alleen lage voorraad": "Only low stock",
  "Alleen met licentie": "Only with license",
  "Alleen voor PRO/Enterprise plan": "Only for PRO/Enterprise plan",
  "Alles": "All",
  "Alles aanvinken": "Check all",
  "Alles onder controle — geen openstaande acties.": "Everything under control — no open actions.",
  "Alles ontvangen": "All received",
  "Alles selecteren": "Select all",
  "Alles toevoegen": "Add all",
  "Alles uitvinken": "Uncheck all",
  "Allow customers to request appointments themselves via a shareable link.": "Allow customers to request appointments themselves via a shareable link.",
  "Als": "As",
  "Als dit e-mailadres bekend is, hebben we een reset-link gestuurd.": "If this email address is known, we have sent a reset link.",
  "Altijd gratis · voor zzp & starters": "Always free · for freelancers & startups",
  "Analyse klaar — controleer voor opslaan": "Analysis complete — review before saving",
  "Analyse mislukt": "Analysis failed",
  "Andere locatie…": "Other location…",
  "Annuleren": "Cancel",
  "Aparte \"Advertentie maken\"-tool: kenteken invullen en klaar": "Separate \"Create Advertisement\" tool: enter license plate and done",
  "App password": "App password",
  "Apparaat / browser": "Device / browser",
  "Apparaat afgemeld": "Device logged out",
  "Apparaatbeheer + activatielogboek per licentie (misbruikbeveiliging)": "Device management + activation log per license (abuse prevention)",
  "Apparaatlimiet bereikt": "Device limit reached",
  "Apparaten": "Devices",
  "Apparaten die 90 dagen niet zijn gebruikt worden automatisch verwijderd.": "Devices not used for 90 days will be automatically removed.",
  "Argentinië": "Argentina",
  "Armenië": "Armenia",
  "Artikelhistorie": "Item history",
  "Audit log-bewaartermijn": "Audit log retention period",
  "Australië": "Australia",
  "Auto": "Vehicle",
  "Auto bewerken": "Edit vehicle",
  "Auto gebracht": "Vehicle dropped off",
  "Auto handel": "Vehicle trade",
  "Auto handel marge": "Vehicle trade margin",
  "Auto handel toegevoegd": "Vehicle trade added",
  "Auto opgeslagen": "Vehicle saved",
  "Auto toevoegen": "Add vehicle",
  "Auto toevoegen (mock)": "Add vehicle (mock)",
  "Auto verwijderd": "Vehicle deleted",
  "Auto verwijderen?": "Delete vehicle?",
  "Auto-advertenties met één klik publiceren (concept / gepubliceerd / verwijderen)": "Publish vehicle ads with one click (draft / published / delete)",
  "Auto-backup aan": "Auto-backup on",
  "Auto-backup off": "Auto-backup off",
  "Auto-backup on": "Auto-backup on",
  "Auto-backup uit": "Auto-backup off",
  "Auto-handel": "Vehicle trade",
  "Auto-translate failed": "Auto-translate failed",
  "Auto-translation failed": "Auto-translation failed",
  "Auto-vertalen mislukt": "Auto-translation failed",
  "Autohandel marge": "Vehicle trade margin",
  "Automatically fill empty keys via AI": "Automatically fill empty keys via AI",
  "Automatische betalingsherinneringen": "Automatic payment reminders",
  "Automatische bevestigings- en herinneringsmails": "Automatic confirmation and reminder emails",
  "Automatische nachtelijke back-up": "Automatic nightly backup",
  "Automatische onderdelenlijst per type (scooter: kuipdelen/variomatic, aanhanger: as/dissel, caravan: keuken/koelkast…)": "Automatic parts list by type (scooter: fairing parts/variomatic, trailer: axle/drawbar, caravan: kitchen/refrigerator…)",
  "Autopapieren scannen met AI": "Scan vehicle documents with AI",
  "Average per service": "Average per service",
  "BASIC limieten actief: max 50 klanten · 30 bonnen/maand · 1 gebruiker · geen cloud · geen auto-handel.": "BASIC limits active: max 50 customers · 30 receipts/month · 1 user · no cloud · no vehicle trade.",
  "BETAALD": "PAID",
  "BPM / rest-BPM gecontroleerd (bij import)": "BPM / residual BPM checked (for import)",
  "BTW": "VAT",
  "BTW nummer": "VAT number",
  "BTW voorbelasting (terug te vragen)": "Input VAT (refundable)",
  "BTW-AANGIFTE": "VAT RETURN",
  "BTW-aangifte": "VAT return",
  "BTW-aangifte & winst-/verliesrekening per kwartaal": "VAT return & profit/loss statement per quarter",
  "BTW-aangifte overzicht en winst- & verliesrekening per kwartaal of jaar": "VAT return overview and profit & loss statement per quarter or year",
  "BTW-aangifte overzicht en winst- & verliesrekening per periode": "VAT return overview and profit & loss statement per period",
  "BTW-tarief": "VAT rate",
  "Back-up": "Backup",
  "Back-up bestand selecteren": "Select backup file",
  "Back-up gedownload": "Backup downloaded",
  "Back-up mislukt": "Backup failed",
  "Back-up nu naar cloud": "Backup to cloud now",
  "Bagijnhof 33": "Bagijnhof 33",
  "Balans": "Balance sheet",
  "Banden inslaan": "Tire purchase",
  "Banden uitgegeven": "Tires issued",
  "Banden uitgeven": "Issue tires",
  "Bandenhotel": "Tire storage",
  "Bandenmaat": "Tire size",
  "Bandenset bewerken": "Edit tire set",
  "Bandenset verwijderen?": "Delete tire set?",
  "Bank": "Bank",
  "Bankafschrift-import (MT940 / CAMT.053) met automatisch matchen aan facturen en kosten": "Bank statement import (MT940 / CAMT.053) with automatic matching to invoices and expenses",
  "Bankimport": "Bank import",
  "Banner geüpload": "Banner uploaded",
  "Banner ingesteld ✓": "Banner set ✓",
  "Banner uploaden": "Upload banner",
  "Banner vervangen": "Replace banner",
  "Banner verwijderd": "Banner removed",
  "Banner-afbeelding (bovenaan showroom)": "Banner image (top of showroom)",
  "Bedankt voor uw akkoord!": "Thank you for your agreement!",
  "Bedankt voor uw betaling.": "Thank you for your payment.",
  "Bedankt voor uw vertrouwen in": "Thank you for your trust in",
  "Bedankt voor uw vertrouwen in onze garage!": "Thank you for your trust in our garage!",
  "Bedrag": "Amount",
  "Bedrag (excl. BTW)": "Amount (excl. VAT)",
  "Bedrag (€)": "Amount (€)",
  "Bedrag excl. BTW (€)": "Amount excl. VAT (€)",
  "Bedrag is exclusief BTW.": "Amount excludes VAT.",
  "Bedragen die met één klik als regel op een bon kunnen worden gezet.": "Amounts that can be added as a line item to a receipt with one click.",
  "Bedrijfsinformatie": "Company information",
  "Bedrijfslogo op factuur": "Company logo on invoice",
  "Bedrijfsnaam": "Company name",
  "Begin met deze 3 stappen om je garage op te zetten:": "Start with these 3 steps to set up your garage:",
  "Begin met typen...": "Start typing...",
  "Begrijp OBD-/DTC-codes: oorzaken, onderdelen en arbeidstijd": "Understand OBD/DTC codes: causes, parts, and labor time",
  "Beheer gebruikte én nieuwe onderdelen, sloopauto's en advertenties vanuit één systeem.": "Manage used and new parts, scrap cars, and advertisements from one system.",
  "Beheer locaties zoals Brug 1, Brug 2, Magazijn A of Schap 3. Ze verschijnen als keuzelijst bij onderdelen en in de werkplaatsplanning.": "Manage locations such as Bay 1, Bay 2, Warehouse A, or Shelf 3. They appear as a selection list for parts and in workshop planning.",
  "Bekijk": "View",
  "Bekijk en klik \"Opslaan\" om te bewaren.": "View and click \"Save\" to keep.",
  "Bekijk onze occasions en onderdelen": "View our used cars and parts",
  "Bekijk onze occasions en onderdelen en neem gerust contact op.": "View our used cars and parts and feel free to contact us.",
  "Bekijk op AutoScout24": "View on AutoScout24",
  "Bekijk op Gaspedaal": "View on Gaspedaal",
  "Bekijk op Marktplaats": "View on Marktplaats",
  "Bekijk showroom": "View showroom",
  "België": "Belgium",
  "Bellen": "Call",
  "Benodigde onderdelen": "Required parts",
  "Bepaal marktprijs": "Determine market price",
  "Bepaal waarde": "Determine value",
  "Beschikbaar bij klantvoertuigen, auto handel én de advertentiemaker": "Available for customer vehicles, vehicle trade, and the ad creator",
  "Beschikbaarheid laden…": "Loading availability…",
  "Beschikbare plannen": "Available plans",
  "Beschrijf de klacht en klik op \"Maak offerte-voorstel\" voor AI-offerteregels.": "Describe the complaint and click \"Create quote proposal\" for AI quote lines.",
  "Beschrijf de klacht of het uit te voeren werk": "Describe the complaint or the work to be performed",
  "Beschrijving": "Description",
  "Bespaar elk kwartaal uren werk en stuur je boekhouder met 1 klik een compleet rapport.": "Save hours of work every quarter and send your accountant a complete report with 1 click.",
  "Bestaande klant": "Existing customer",
  "Bestaande klant gevonden — wordt gekoppeld": "Existing customer found — linking",
  "Bestaat al": "Already exists",
  "Bestand ingelezen": "File imported",
  "Beste": "Dear",
  "Bestel": "Order",
  "Besteld": "Ordered",
  "Bestellen": "Order",
  "Bestellen mislukt": "Order failed",
  "Bestellijst": "Order list",
  "Bestelling": "Order",
  "Bestelling annuleren?": "Cancel order?",
  "Bestelling geannuleerd": "Order cancelled",
  "Bestellingen": "Orders",
  "Bestellingen beheer": "Order management",
  "Betaal via PayPal": "Pay via PayPal",
  "Betaal-/licentiegegevens:": "Payment/License Details:",
  "Betaal-QR": "Payment QR",
  "Betaal-QR (SEPA) op de factuur — klant scant en betaalt met de bankapp, geen provider nodig": "Payment QR (SEPA) on the invoice — customer scans and pays with their banking app, no provider needed",
  "Betaald": "Paid",
  "Betaalgegevens worden binnenkort toegevoegd. Je ontvangt de instructies per e-mail.": "Payment details will be added soon. You will receive instructions by email.",
  "Betaalinformatie": "Payment Information",
  "Betaaltermijn": "Payment Term",
  "Betaaltermijn (dagen)": "Payment Term (days)",
  "Betalen via bankoverschrijving of PayPal · Licentiekey automatisch per e-mail na ontvangst van je betaling": "Pay via bank transfer or PayPal · License key automatically emailed after payment is received",
  "Betaling": "Payment",
  "Betaling bewerken": "Edit Payment",
  "Betaling niet gevonden": "Payment not found",
  "Betaling ontvangen": "Payment received",
  "Betaling ontvangen → licentie automatisch genereren + mailen": "Payment received → automatically generate and email license",
  "Betaling succesvol!": "Payment successful!",
  "Betaling toegevoegd": "Payment added",
  "Betaling toevoegen": "Add Payment",
  "Betaling van bestelling ontvangen? De licentie wordt direct gegenereerd en gemaild.": "Payment for order received? The license will be generated and emailed instantly.",
  "Betaling verwerken...": "Processing payment...",
  "Betaling verwijderd": "Payment deleted",
  "Betaling verwijderen?": "Delete payment?",
  "Betaling vindt plaats via de aangeboden betaalmethoden.": "Payment is made using the offered payment methods.",
  "Betalingen": "Payments",
  "Betalingen van bon": "Payments for receipt",
  "Betalingen, Auto handel, Planning, Meldingen (APK), Onderdelen, Rapportage, Documenten en Werkkaart": "Payments, Vehicle trade, Planning, Notifications (MOT), Parts, Reporting, Documents, and Work order",
  "Betalingen: (deel)betaling per factuur bewerken/verwijderen rechtstreeks vanuit \"Openstaande bonnen\"": "Payments: edit/delete (partial) payment per invoice directly from \"Outstanding receipts\"",
  "Betalingsbewijs / Kwitantie": "Proof of Payment / Receipt",
  "Betalingsherinnering": "Payment Reminder",
  "Betalingsherinnering mailen": "Email Payment Reminder",
  "Betalingskenmerk": "Payment Reference",
  "Betekenis": "Meaning",
  "Bevestiging": "Confirmation",
  "Bevestiging verstuurd": "Confirmation sent",
  "Bevindingen proefrit": "Test drive findings",
  "Bevindingen, gebruikte onderdelen, bijzonderheden…": "Findings, parts used, special notes…",
  "Bewaar": "Save",
  "Bewaar hier je eigen kortingscodes per shop. Ze verschijnen dan bij de knop hierboven.": "Save your custom discount codes per shop here. They will appear next to the button above.",
  "Bewerkbaar controlescherm met betrouwbaarheids-indicatoren per veld": "Editable inspection screen with reliability indicators per field",
  "Bewerken": "Edit",
  "Bezig": "In progress",
  "Bezig met laden": "Loading",
  "Bezig met zoeken...": "Searching...",
  "Bezig...": "Working...",
  "Bezig…": "Working…",
  "Bezoekers (views)": "Visitors (views)",
  "Bezoekers kunnen zelf van taal wisselen via een duidelijke taalkeuze; een melding laat zien wanneer de taal automatisch is gekozen": "Visitors can switch language themselves via a clear language selector; a notice shows when the language was detected automatically",
  "Bij uitblijven van betaling kan toegang tot de dienst worden beperkt of beëindigd.": "Failure to pay may result in restricted or terminated access to the service.",
  "Bijbestellen": "Reorder",
  "Bijgewerkt": "Updated",
  "Bijna klaar — betaal je bestelling": "Almost done — pay for your order",
  "Bijv. 06J115403Q": "E.g. 06J115403Q",
  "Bijv. 12-AB-34, Jan de Vries, of B-2025-0042...": "E.g. 12-AB-34, Jan de Vries, or B-2025-0042...",
  "Bijv. Brug 1": "E.g. Bay 1",
  "Bijv. Brug 3 of Buitenplaats": "E.g. Bay 3 or Outdoor Space",
  "Bijv. Schap 3": "E.g. Shelf 3",
  "Bijwerken": "Update",
  "Binnenkort beschikbaar": "Coming soon",
  "Binnenkort: AI-waardebepaling, past-op-analyse en onderdeel-advertenties": "Coming soon: AI valuation, 'fits-on' analysis and parts advertisements",
  "Bj": "Yr.",
  "Bladeren per categorie en voertuig, met koppeling naar je leveranciers": "Browse by category and vehicle, linked to your suppliers",
  "Boekhoud-suite: Debiteurenbeheer, Kosten/inkoopfacturen, automatische herinneringen, BTW & Winst, Grootboek en Balans": "Accounting suite: Debtor management, Cost/purchase invoices, automatic reminders, VAT & Profit, General Ledger and Balance Sheet",
  "Boekhouding": "Accounting",
  "Boekhouding is al up-to-date": "Accounting is already up-to-date",
  "Boekhouding — BTW & Winst": "Accounting — VAT & Profit",
  "Boekhoudrapport": "Accounting Report",
  "Boekingen": "Bookings",
  "Bon": "Receipt",
  "Bon aangemaakt": "Receipt created",
  "Bon layout": "Receipt layout",
  "Bon layout: pas layout aan en bekijk het resultaat direct naast elkaar": "Receipt layout: adjust layout and view the result side-by-side",
  "Bon opgeslagen": "Receipt saved",
  "Bon verwijderd": "Receipt deleted",
  "Bon verwijderen?": "Delete Receipt?",
  "Bonnen": "Receipts",
  "Bonnen & facturen met eigen logo, BTW/hobby-modus en print/PDF": "Receipts & invoices with custom logo, VAT/hobby mode and print/PDF",
  "Bonnen samenvatting": "Receipts Summary",
  "Bonnummer": "Receipt Number",
  "Bosnië en Herzegovina": "Bosnia and Herzegovina",
  "Bouwjaar": "Year",
  "Bouwjaar (nieuw → oud)": "Year of manufacture (new → old)",
  "Bouwjaar tot": "Year to",
  "Bouwjaar van": "Year from",
  "Boven marktprijs — kan verkoop vertragen": "Above market price — may slow sales",
  "Brandstof": "Fuel",
  "Brazilië": "Brazil",
  "Break-even": "Break-even",
  "Bruggen / werkplekken": "Lifts / Work Bays",
  "Bruggen / werkplekken toewijzen (instelbaar aantal) + monteur per klus": "Assign lifts / workstations (configurable number) + mechanic per job",
  "Bruggen beheren": "Manage Lifts",
  "Bruggen opgeslagen": "Lifts saved",
  "Bv. 124500": "e.g. 124500",
  "Bv. Jan de Vries": "e.g. Jan de Vries",
  "Bv. Schap 3": "e.g. Shelf 3",
  "Camera starten…": "Start camera…",
  "Capaciteitswaarschuwing bij dubbele boeking (zelfde brug of monteur)": "Capacity warning for double booking (same lift or mechanic)",
  "Categorie": "Category",
  "Categorie wijzigen": "Change Category",
  "Chassisnummer (VIN)": "Chassis Number (VIN)",
  "Chassisnummer check (VIN)": "Chassis Number (VIN) Check",
  "Check je inbox": "Check your inbox",
  "Check je spam-map. De mail kan tot een minuut duren.": "Check your spam folder. The email may take up to a minute to arrive.",
  "Check mijn voorraad voor dit voertuig": "Check my stock for this vehicle",
  "Checkout mislukt": "Checkout failed",
  "Choose the plan that fits your garage": "Choose the plan that fits your garage",
  "Choose the plan that suits your garage": "Choose the plan that suits your garage",
  "Claim opgeslagen": "Claim saved",
  "Claim verwijderen?": "Delete Claim?",
  "Cloud back-up gelukt": "Cloud backup successful",
  "Cloud back-up mislukt": "Cloud backup failed",
  "Cloud koppeling verbreken?": "Disconnect Cloud?",
  "Cloud losgekoppeld": "Cloud disconnected",
  "Cloud loskoppelen": "Disconnect Cloud",
  "Cloud sync": "Cloud Sync",
  "Cloud sync vereist een actieve licentie. Ga naar het Licentie tabblad om te activeren.": "Cloud sync requires an active license. Go to the License tab to activate it.",
  "Cloud verbonden!": "Cloud connected!",
  "Cloud-synchronisatie van documenten (Dropbox & Google Drive)": "Cloud sync for documents (Dropbox & Google Drive)",
  "Code": "Code",
  "Code is verplicht": "Code required",
  "Compatibel (\"past op\")": "Compatible (fits)",
  "Concurrentie (indicatie)": "Competition (Indicative)",
  "Conditie": "Condition",
  "Contact": "Contact",
  "Contact:": "Contact:",
  "Contactaanvragen": "Contact Requests",
  "Contactpersoon": "Contact Person",
  "Contant": "Cash",
  "Controleer voor opslaan": "Check before saving",
  "Controlepunt": "Checkpoint",
  "Costs per category": "Costs per category",
  "Create a first customer + vehicle via": "Create your first customer + vehicle via",
  "Create your first work order or invoice via": "Create your first work order or invoice via",
  "Created via Diagnosis": "Created via Diagnosis",
  "Credit": "Credit",
  "Crediteren": "Credit",
  "Crediteren mislukt": "Credit failed",
  "Creditfactuur aangemaakt": "Credit invoice created",
  "Creditfactuur maken voor": "Create credit invoice for",
  "Creditfactuur met 1 klik (negatieve factuur, gekoppeld aan het origineel)": "One-click credit invoice (negative invoice, linked to original)",
  "Creditfactuur op": "Credit invoice on",
  "Curaçao": "Curaçao",
  "Custom": "Custom",
  "Customer and vehicle details (entered by garage):": "Customer and vehicle details (entered by garage):",
  "DEELS BETAALD": "PARTIALLY PAID",
  "DOT / bouwweek": "DOT / manufacturing week",
  "Dag": "Day",
  "Dagen": "Days",
  "Dagen in voorraad": "Days in stock",
  "Dagplanning": "Daily planning",
  "Dagplanning afdrukken, gegroepeerd per brug": "Print daily schedule, grouped by bay",
  "Dashboard met omzet-KPI's, openstaande facturen, planning en voorraad-alerts": "Dashboard with revenue KPIs, outstanding invoices, schedule, and stock alerts",
  "Datum": "Date",
  "De AI bekijkt je foto's en herkent kenmerken (velgen, trekhaak, schade, staat) voor de advertentie en waardebepaling.": "The AI analyzes your photos and identifies features (rims, tow bar, damage, condition) for the advertisement and valuation.",
  "De AI bekijkt je foto\\'s en herkent kenmerken (velgen, trekhaak, schade, staat) voor de advertentie en waardebepaling.": "The AI analyzes your photos and recognizes features (rims, tow bar, damage, condition) for the advertisement and valuation.",
  "De Groot Onderhoud": "De Groot Maintenance",
  "De RDW-kentekencheck en het kwartaalrapport naar mijn boekhouder werken vlekkeloos. Echt een aanrader.": "The RDW license plate check and the quarterly report to my accountant work flawlessly. Highly recommended.",
  "De basis: complete garage-software": "The basics: complete garage software",
  "De eerste foto is de hoofdfoto. Klik op de ster om een andere foto als hoofdfoto in te stellen.": "The first photo is the main photo. Click the star to set another photo as the main photo.",
  "De exacte inhoud van de dienst kan op ieder moment worden aangepast, uitgebreid of gewijzigd.": "The exact content of the service may be adjusted, expanded, or changed at any time.",
  "De klant blijft volledig verantwoordelijk voor ingevoerde gegevens, documenten, afbeeldingen, voertuiginformatie, klantinformatie en boekhoudkundige gegevens.": "The customer remains solely responsible for entered data, documents, images, vehicle information, customer information, and accounting data.",
  "De klant blijft zelf verantwoordelijk voor het regelmatig maken en controleren van back-ups. MonteurCentraal is niet aansprakelijk voor verlies van gegevens, ongeacht de oorzaak.": "The customer remains responsible for regularly creating and checking backups. MonteurCentraal is not liable for data loss, regardless of the cause.",
  "De klant is verantwoordelijk voor alle activiteiten die plaatsvinden onder het eigen account.": "The customer is responsible for all activities that occur under their account.",
  "De klant is verantwoordelijk voor het geheimhouden van inloggegevens.": "The customer is responsible for keeping login credentials confidential.",
  "De klant kan het gebruik van de dienst op ieder moment beëindigen.": "The customer may terminate the use of the service at any time.",
  "De klant verkrijgt uitsluitend een beperkt gebruiksrecht.": "The customer only obtains a limited right of use.",
  "De klant vrijwaart MonteurCentraal tegen alle aanspraken van derden die voortvloeien uit het gebruik van de dienst, ingevoerde gegevens, gegenereerde documenten, advertenties, facturen, boekhoudkundige gegevens, klantgegevens of voertuiggegevens.": "The customer indemnifies MonteurCentraal against all third-party claims arising from the use of the service, entered data, generated documents, advertisements, invoices, accounting data, customer data, or vehicle data.",
  "De online afspraken-pagina vult mijn agenda vanzelf. Klanten boeken nu 's avonds zelf, scheelt enorm veel bellen.": "The online appointment page fills my calendar automatically. Customers now book themselves in the evenings, saving a lot of calls.",
  "De som van alle aandelen zou idealiter 100% moeten zijn.": "The sum of all shares should ideally be 100%.",
  "De som van alle winstaandelen is": "The sum of all profit shares is",
  "Debet": "Debit",
  "Debiteurenbeheer": "Debtor management",
  "Debiteurenbeheer met ouderdomsanalyse (aging)": "Accounts receivable management with aging analysis",
  "Deel": "Share",
  "Deel deze link met je klanten zodat zij zelf afspraken kunnen aanvragen. Beheer diensten en openingstijden onder": "Share this link with your customers so they can request appointments themselves. Manage services and opening hours under",
  "Deel via WhatsApp": "Share via WhatsApp",
  "Deelbare boekingslink voor je website & social media": "Shareable booking link for your website & social media",
  "Deelbare boekingslink, diensten + duur, openingstijden en slot-instellingen": "Shareable booking link, services + duration, opening hours, and slot settings",
  "Deelfactuur": "Split invoice",
  "Deelfactuur / termijn + aanbetaling en kilometerstand op de factuur": "Partial invoice / installment + deposit and mileage on the invoice",
  "Deelfactuur aangemaakt": "Split invoice created",
  "Deelfactuur maken": "Create split invoice",
  "Deelfactuur mislukt": "Split invoice failed",
  "Deelontvangst geboekt": "Partial receipt booked",
  "Deeplinks": "Deeplinks",
  "Deeplinks kopiëren": "Copy deeplinks",
  "Defect / voor onderdelen": "Defective / for parts",
  "Delen via WhatsApp + exporteren als PDF": "Share via WhatsApp + export as PDF",
  "Demontage": "Disassembly",
  "Demontagedatum": "Disassembly date",
  "Detail": "Detail",
  "Deze algemene voorwaarden zijn van toepassing op ieder gebruik van de software, website, diensten en functionaliteiten van MonteurCentraal.": "These general terms and conditions apply to all use of MonteurCentraal's software, website, services, and functionalities.",
  "Deze beperking geldt niet voor aansprakelijkheid die volgens Nederlands recht niet mag worden uitgesloten.": "This limitation does not apply to liability that cannot be excluded under Dutch law.",
  "Deze bon is opgesteld in hobby-/particulier-modus. Er wordt geen BTW in rekening gebracht.": "This receipt was created in hobby/private mode. No VAT is charged.",
  "Deze instellingen worden gebruikt op alle nieuwe bonnen, offertes en facturen van": "These settings are used on all new receipts, quotes, and invoices from",
  "Deze klant heeft geen e-mailadres": "This customer has no email address",
  "Deze maand": "This month",
  "Deze voorwaarden gelden voor alle gebruikers van MonteurCentraal. Indien een bepaling ongeldig blijkt te zijn, blijven de overige bepalingen volledig van kracht.": "These terms and conditions apply to all users of MonteurCentraal. Should any provision be deemed invalid, the remaining provisions shall remain in full force and effect.",
  "Deze week": "This week",
  "Diagnose definitief vastleggen...": "Finalize diagnosis...",
  "Diagnose opgeslagen": "Diagnosis saved",
  "Diagnosestappen": "Diagnosis steps",
  "Dicht": "Close",
  "Dienst": "Service",
  "Dienst toevoegen": "Add service",
  "Dienst:": "Service:",
  "Diensten & duur": "Services & duration",
  "Diensten met eigen duur (APK, onderhoud, banden…)": "Services with custom duration (MOT, maintenance, tires…)",
  "Digitale werkorder": "Digital work order",
  "Direct vanuit de advertentie publiceren in je showroom": "Publish directly from the ad to your showroom",
  "Distributieriem recent vervangen": "Timing belt recently replaced",
  "Distributieriem vervangen": "Replace timing belt",
  "Distributieriem vervangen bij 200.000 km": "Timing belt replacement at 200,000 km",
  "Dit duurt enkele seconden": "This will take a few seconds",
  "Dit is een voorbeeld. De weergave kan afwijken van het echte platform.": "This is an example. The display may differ from the actual platform.",
  "Dit is mock-data zonder echt bestand. Upload nieuwe documenten voor echte downloads.": "This is mock data without a real file. Upload new documents for actual downloads.",
  "Dit jaar": "This year",
  "Dit kwartaal": "This quarter",
  "Dit voertuig bestaat al — er wordt geen dubbele aangemaakt": "This vehicle already exists — no duplicate will be created",
  "Dit zijn garages zonder actieve betaalde licentie — potentiële upgrade-leads. Klik op een e-mailadres om contact op te nemen.": "These are garages without an active paid license — potential upgrade leads. Click an email address to contact.",
  "Document": "Document",
  "Document verwijderd": "Document deleted",
  "Document verwijderen?": "Delete document?",
  "Documenten": "Documents",
  "Documenten: upload PDF/foto, sync naar cloud bij actieve licentie": "Documents: upload PDF/photo, sync to cloud with active license",
  "Documenttitel": "Document title",
  "Donker": "Dark",
  "Donor-sloopauto koppelen vanuit de onderdeelkaart — vult automatisch \"afkomstig van\", kenteken, merk en bouwjaar": "Link donor salvage vehicle from the parts card — automatically fills \"originating from\", license plate, make, and year of manufacture",
  "Donorvoertuig": "Donor vehicle",
  "Door": "By",
  "Door een account aan te maken of gebruik te maken van de dienst verklaart de gebruiker akkoord te gaan met deze voorwaarden.": "By creating an account or using the service, the user agrees to these terms and conditions.",
  "Door te ondertekenen gaat u akkoord met de werkzaamheden. Datum, tijd en apparaatgegevens worden vastgelegd.": "By signing, you agree to the work performed. Date, time, and device data will be recorded.",
  "Doorgaan met invoeren": "Continue entering",
  "Doorgaan naar app": "Continue to app",
  "Download back-up": "Download backup",
  "Download een complete JSON snapshot van alle data (klanten, voertuigen, bonnen, planning, voorraad, betalingen, etc). Bewaar dit bestand op een veilige plek (Dropbox / Google Drive / externe schijf).": "Download a complete JSON snapshot of all data (customers, vehicles, receipts, schedule, stock, payments, etc). Store this file in a safe place (Dropbox / Google Drive / external drive).",
  "Download foto\\'s": "Download photos",
  "Download mislukt": "Download failed",
  "Drukgroep en druklager worden vaak samen met een koppeling vervangen.": "Pressure plate and release bearing are often replaced together with a clutch.",
  "Dubbel boekhouden — saldi per grootboekrekening, automatisch geboekt": "Double-entry bookkeeping — balances per ledger account, automatically posted",
  "Dubbel boekhouden — saldi per grootboekrekening, automatisch geboekt uit je facturen, betalingen en kosten": "Double-entry bookkeeping — ledger account balances, automatically posted from your invoices, payments, and expenses",
  "Dubbelklik om te bewerken": "Double-click to edit",
  "Duur": "Duration",
  "Duur (minuten)": "Duration (minutes)",
  "E-mail": "Email",
  "E-mail (mock)": "Email (mock)",
  "E-mail / gebruikersnaam": "Email / username",
  "E-mail eigenaar": "Owner email",
  "E-mail mislukt": "Email failed",
  "E-mail niet geconfigureerd": "Email not configured",
  "E-mail verstuurd": "Email sent",
  "E-mailactivatie bij registratie + wachtwoord-reset (Resend)": "Email activation upon registration + password reset (Resend)",
  "E-mailadres boekhouder": "Accountant's email address",
  "E-mailherinnering voor APK rechtstreeks naar de klant": "MOT email reminder directly to the customer",
  "E.g. 12-AB-34, Jan de Vries, or B-2025-0042...": "E.g. 12-AB-34, Jan de Vries, or B-2025-0042...",
  "Each customer will receive a maximum of 1 email per level (consolidating all outstanding invoices). Customers without an email address will be skipped.": "Each customer will receive a maximum of 1 email per level (consolidating all outstanding invoices). Customers without an email address will be skipped.",
  "Editor": "Editor",
  "Een eigen boekingspagina die 24/7 doorwerkt — ook als jij onder een auto ligt.": "Your own booking page that works 24/7 — even when you're under a car.",
  "Een licentie geeft uitsluitend een gebruiksrecht. De software wordt niet verkocht.": "A license grants a right of use only. The software is not sold.",
  "Een licentie wordt gebonden aan jouw garage bij activatie - hergebruik door een andere garage wordt geblokkeerd.": "A license is tied to your garage upon activation - reuse by another garage is blocked.",
  "Eerlijke vermelding van schade/aandachtspunten + sterke/verbeterpunten": "Honest listing of damage/attention points + strengths/areas for improvement",
  "Eerste activatie": "First activation",
  "Eigen app-icoon en offline-melding bij geen verbinding": "Custom app icon and offline notification when no connection",
  "Eigen kortingscodes": "Custom discount codes",
  "Eigen link: monteurcentraal.com/showroom/jouw-garage": "Custom link: monteurcentraal.com/showroom/your-garage",
  "Eigen onderdeel toevoegen…": "Add custom part…",
  "Eigen publieke verkooppagina: monteurcentraal.com/showroom/jouw-garage": "Custom public sales page: monteurcentraal.com/showroom/your-garage",
  "Eigenaar": "Owner",
  "Eindelijk alles op één plek. Facturen, planning én boekhouding. Bespaart me elke week uren administratie.": "Finally, everything in one place. Invoices, scheduling, and accounting. Saves me hours of admin every week.",
  "Elke klant ontvangt per niveau maximaal 1 e-mail (gebundeld over alle openstaande facturen). Klanten zonder e-mailadres worden overgeslagen.": "Each customer will receive a maximum of 1 email per level (consolidating all outstanding invoices). Customers without an email address will be skipped.",
  "Enter at least license plate or make/model": "Enter at least license plate or make/model",
  "Enter city and street via postcode + house number": "Enter city and street via postcode + house number",
  "Enter postcode via street + city": "Enter postcode via street + city",
  "Enter postcode via street + house number + city": "Enter postcode via street + house number + city",
  "Enthousiast": "Enthusiastic",
  "Er ging iets mis. Probeer het later opnieuw.": "Something went wrong. Please try again later.",
  "Er ging iets mis. Probeer het opnieuw.": "Something went wrong. Please try again.",
  "Er ging iets mis:": "Something went wrong:",
  "Er is geen lopend werk.": "No ongoing work.",
  "Er staan al credentials opgeslagen voor dit account.": "Credentials already saved for this account.",
  "Ethiopië": "Ethiopia",
  "Even geduld, we controleren je betaling": "Please wait, we're checking your payment",
  "Eventuele juridische kosten en schade voortvloeiend uit dergelijke aanspraken komen voor rekening van de klant.": "Any legal costs and damages arising from such claims will be borne by the customer.",
  "Excl. BTW": "Excl. VAT",
  "Export boekhouder": "Accountant Export",
  "Export gestart": "Export started",
  "Export naar Excel (mock)": "Export to Excel (mock)",
  "Export voor de boekhouder (CSV met alle facturen & creditfacturen)": "Export for the accountant (CSV with all invoices & credit invoices)",
  "Exporteer een afschrift uit je bankieromgeving (ING/Rabobank/ABN AMRO) als MT940 (.sta/.txt) of CAMT.053 (.xml) en sleep het hier in.": "Export a statement from your banking environment (ING/Rabobank/ABN AMRO) as MT940 (.sta/.txt) or CAMT.053 (.xml) and drag it here.",
  "Exporteren (CSV)": "Export (CSV)",
  "Exporteren (PDF)": "Export (PDF)",
  "Extra info (optioneel)": "Additional info (optional)",
  "Eén klik en je auto staat online te koop": "One click, and your car is online for sale.",
  "Facebook staat automatisch plaatsen niet toe. Met deze knop kopiëren we de tekst, downloaden we je foto's en openen we Facebook Marketplace — daar plak je de tekst en sleep je de foto's erin.": "Facebook does not allow automatic posting. With this button, we copy the text, download your photos, and open Facebook Marketplace — there you paste the text and drag in the photos.",
  "Facebook staat automatisch plaatsen niet toe. Met deze knop kopiëren we de tekst, downloaden we je foto\\'s en openen we Facebook Marketplace — daar plak je de tekst en sleep je de foto\\'s erin.": "Facebook does not allow automatic posting. This button will copy the text, download your photos, and open Facebook Marketplace. You can then paste the text and drag in the photos there.",
  "Facturatie en licentiebeheer (uitvoering overeenkomst / wettelijke plicht).": "Invoicing and license management (contract fulfillment / legal obligation).",
  "Facturen met eigen logo": "Invoices with custom logo",
  "Factuur": "Invoice",
  "Factuur aan": "Invoice to",
  "Factuur aanmaken": "Create invoice",
  "Factuurnr.": "Invoice no.",
  "Factuurnummer": "Invoice number",
  "Factuurnummers per jaar (F-2026-0001 …) met automatische reset per jaar": "Invoice numbers per year (F-2026-0001 …) with automatic annual reset",
  "Faeröer": "Faroe Islands",
  "Februari–Mei 2026": "February–May 2026",
  "Fetch make/model/year via chassis number": "Fetch make/model/year via chassis number",
  "Fill in via postcode": "Fill in via postcode",
  "Financiële en operationele rapporten": "Financial and operational reports",
  "Find postcode via street + city": "Find postcode via street + city",
  "Flip-calculatie": "Flip calculation",
  "Fooi": "Tip",
  "Fooi (€)": "Tip (€)",
  "Fooi moet tussen 0 en het bedrag liggen": "Tip must be between 0 and the total amount",
  "Foto's": "Photos",
  "Foto's toegevoegd — analyseren met AI…": "Photos added — analyzing with AI…",
  "Foto's uploaden voor waardebepaling": "Upload photos for valuation",
  "Foto's uploaden → AI herkent het onderdeel en vult automatisch naam, categorie, merk, nummers, conditie en prijs in": "Upload photos → AI recognizes the part and automatically fills in name, category, brand, numbers, condition, and price",
  "Foto-analyse, winstberekening, verkoopscore, verwachte verkooptijd en concurrentie": "Photo analysis, profit calculation, sales score, estimated sales time, and competition",
  "Foto-analyse: AI herkent velgen, trekhaak, schade en staat": "Photo analysis: AI recognizes rims, tow hitch, damage, and condition",
  "Foto\\'s": "Photos",
  "Foto\\'s (max 6) — AI herkent opties & schade": "Photos (max 6) — AI identifies options & damage",
  "Foto\\'s gedownload": "Photos downloaded",
  "Foto\\'s toegevoegd — analyseren met AI…": "Photos added — analyzing with AI…",
  "Foto\\'s uploaden": "Upload photos",
  "Foto\\'s uploaden voor waardebepaling": "Upload photos for valuation",
  "Fotoanalyse mislukt": "Photo analysis failed",
  "Foutcode(s)": "Error code(s)",
  "Foutcodes": "Error codes",
  "Foutcodes (DTC's) automatisch herkend en uitgelegd": "Fault codes (DTCs) automatically recognized and explained",
  "Fraude- en misbruikpreventie (gerechtvaardigd belang).": "Fraud and abuse prevention (legitimate interest).",
  "Functie": "Function",
  "Functies en versies van MonteurCentraal": "Features and versions of MonteurCentraal",
  "Ga naar": "Go to",
  "Garage": "Garage",
  "Garage Account Details:": "Garage Account Details:",
  "Garage El Aoufi": "Garage El Aoufi",
  "Garage Janssen": "Garage Janssen",
  "Garage details saved": "Garage details saved",
  "Garage info": "Garage info",
  "Garage info saved": "Garage info saved",
  "Garage informed by email": "Garage informed by email",
  "Garage is per e-mail geïnformeerd": "Garage informed by email",
  "Garage management": "Garage management",
  "Garage management for modern workshops": "Garage management for modern workshops",
  "Garage management voor moderne werkplaatsen": "Garage management for modern workshops",
  "Garage name": "Garage name",
  "Garage name required": "Garage name required",
  "Garagegegevens opgeslagen": "Garage details saved",
  "Garagenaam": "Garage name",
  "Garagenaam verplicht": "Garage name required",
  "Garages met online boeken vullen hun agenda gemiddeld voller — zonder extra werk.": "Garages with online booking generally fill their schedules more — without extra work.",
  "Garantie (maanden)": "Warranty (months)",
  "Garantie (niet gefactureerd)": "Warranty (unbilled)",
  "Garantieclaim bewerken": "Edit warranty claim",
  "Garantieclaims": "Warranty claims",
  "Geactiveerd op": "Activated on",
  "Geactiveerd!": "Activated!",
  "Geannuleerd": "Cancelled",
  "Gearchiveerd": "Archived",
  "Gebaseerd op km & onderhoud": "Based on km & maintenance",
  "Gebruik adviesprijs als vraagprijs": "Use suggested retail price as asking price",
  "Gebruik deze tekst (OK)": "Use this text (OK)",
  "Gebruiker": "User",
  "Gebruiks- en apparaatgegevens:": "Usage and device data:",
  "Gebruikte marktwaarde": "Used market value",
  "Geef een geldige taalcode (bv. de)": "Please enter a valid language code (e.g., de)",
  "Geef een geldige taalcode (bv. de, fr, es)": "Please provide a valid language code (e.g. de, fr, es)",
  "Geen": "None",
  "Geen (Nederlands) kenteken? Scan de autopapieren — ook buitenlands (bv. Duits) — en de AI vult de gegevens in.": "No Dutch license plate? Scan the vehicle documents — also foreign (e.g. German) — and the AI will fill in the details.",
  "Geen APK's vervallen binnenkort.": "No MOTs expiring soon.",
  "Geen BTW (hobby/particulier)": "No VAT (hobby/private)",
  "Geen BTW van toepassing (hobby/particulier)": "No VAT applicable (hobby/private)",
  "Geen NL-kenteken? Scan de (buitenlandse) autopapieren met AI.": "No NL license plate? Scan the (foreign) vehicle documents with AI.",
  "Geen RDW-gegevens gevonden": "No RDW data found",
  "Geen RDW-gegevens gevonden voor dit kenteken": "No RDW data found for this license plate",
  "Geen actieve licentie — BASIC mode (gratis)": "No active license — BASIC mode (free)",
  "Geen activa": "No assets",
  "Geen activa geboekt": "No assets booked",
  "Geen activiteit voor dit filter.": "No activity for this filter.",
  "Geen afspraken op deze dag.": "No appointments on this day.",
  "Geen afspraken vandaag.": "No appointments today.",
  "Geen artikelen gevonden voor": "No articles found for",
  "Geen auto geselecteerd": "No car selected",
  "Geen beschikbare tijden op deze dag. Kies een andere datum.": "No available times on this day. Please choose another date.",
  "Geen bon geselecteerd": "No receipt selected",
  "Geen bonnen gevonden.": "No receipts found.",
  "Geen camera? Upload hieronder een foto van de code.": "No camera? Upload a photo of the code below.",
  "Geen code": "No code",
  "Geen code gevonden in de foto. Kies een scherpe foto van de QR-/streepjescode.": "No code found in the photo. Please choose a sharp photo of the QR/barcode.",
  "Geen data": "No data",
  "Geen documenten gevonden.": "No documents found.",
  "Geen e-mail verstuurd": "No email sent",
  "Geen e-mailadres bekend": "No email address known",
  "Geen enkele AI-data wordt meer zonder jouw bevestiging weggeschreven": "No AI data will be saved without your confirmation",
  "Geen extra voertuigen gevonden": "No additional vehicles found",
  "Geen foto's om te downloaden": "No photos to download",
  "Geen foto\\'s om te downloaden": "No photos to download",
  "Geen foutcodes": "No fault codes",
  "Geen gratis accounts gevonden.": "No free accounts found.",
  "Geen historie - prijs is nog niet aangepast.": "No history - price has not been adjusted yet.",
  "Geen huisnummer gevonden in adresveld": "No house number found in address field",
  "Geen huisnummer in adres": "No house number in address",
  "Geen kenteken? Upload een foto van de autopapieren (ook buitenlands, bv. Duits) — de AI vult merk, model, bouwjaar enz. in.": "No license plate? Upload a photo of the vehicle documents (also foreign, e.g. German) — the AI will fill in make, model, year of manufacture, etc.",
  "Geen keys gevonden voor": "No keys found for",
  "Geen klant gekoppeld": "No customer linked",
  "Geen klant geselecteerd": "No customer selected",
  "Geen klanten gevonden.": "No customers found.",
  "Geen licentie?": "No license?",
  "Geen logo": "No logo",
  "Geen mail?": "No email?",
  "Geen monteur": "No mechanic",
  "Geen omschrijving": "No description",
  "Geen omzet in deze periode": "No revenue in this period",
  "Geen onderdeel gevonden met code": "No part found with code",
  "Geen onderdelen gevonden.": "No parts found.",
  "Geen openstaande facturen.": "No outstanding invoices.",
  "Geen openstaande facturen. Alle debiteuren hebben betaald!": "No outstanding invoices. All debtors have paid!",
  "Geen openstaande facturen. Alle debiteuren hebben betaald! 🎉": "No outstanding invoices. All debtors have paid! 🎉",
  "Geen passende onderdelen in voorraad gevonden": "No matching parts found in stock",
  "Geen passende onderdelen in voorraad.": "No matching parts in stock.",
  "Geen regels.": "No entries.",
  "Geen resultaat. Probeer opnieuw te genereren.": "No result. Try to generate again.",
  "Geen resultaten": "No results",
  "Geen resultaten gevonden voor": "No results found for",
  "Geen resultaten voor deze filters.": "No results for these filters.",
  "Geen specificaties": "No specifications",
  "Geen teamleden.": "No team members.",
  "Geen toegang": "No access",
  "Geen verborgen kosten. Upgrade of downgrade op elk moment via je licentie key.": "No hidden costs. Upgrade or downgrade at any time via your license key.",
  "Geen vervallen herinneringen om te versturen": "No overdue reminders to send",
  "Geen voertuig gekoppeld": "No vehicle linked",
  "Geen voertuigdata": "No vehicle data",
  "Geen voertuigen": "No vehicles",
  "Geen voertuigen geregistreerd. Klik 'Voertuig toevoegen' hierboven.": "No vehicles registered. Click 'Add Vehicle' above.",
  "Geen voertuigen gevonden.": "No vehicles found.",
  "Geen voorschotten gevonden": "No advances found",
  "Geen voorschotten in deze categorie.": "No advances in this category.",
  "Geen webcam? Maak/kies een foto van de QR- of streepjescode.": "No webcam? Take/choose a photo of the QR or barcode.",
  "Geen werkplek": "No workstation",
  "Gefactureerd": "Invoiced",
  "Gegevens": "Details",
  "Gegevens ingelezen": "Data loaded",
  "Gegevens: garagegegevens en factuurinformatie centraal beheren": "Data: centrally manage garage details and invoice information",
  "Gekopieerd": "Copied",
  "Gekopieerd naar klembord": "Copied to clipboard",
  "Gekopieerd!": "Copied!",
  "Gekoppeld aan": "Linked to",
  "Gekoppelde bon": "Linked receipt",
  "Geldig tot": "Valid until",
  "Gelieve het openstaande bedrag binnen 14 dagen over te maken naar IBAN": "Please transfer the outstanding amount to IBAN within 14 days",
  "Geluiden, trillingen, remweg, sturen…": "Noises, vibrations, braking distance, steering…",
  "Gem. dagen open": "Avg. days open",
  "Gem. factuurwaarde": "Avg. invoice value",
  "Gemiddeld": "Average",
  "Gemiddeld per beurt": "Average per service",
  "Gemiddelde vraagprijs": "Average asking price",
  "Gemini-sleutel opgeslagen en getest ✓": "Gemini key saved and tested ✓",
  "Gemini-sleutel verwijderen? AI-functies werken daarna niet meer.": "Remove Gemini key? AI features will no longer work afterwards.",
  "Genereer": "Generate",
  "Genereer eerst de advertentie": "First generate the advertisement",
  "Genereer met AI een verkoopadvertentie voor losse onderdelen (Marktplaats, Facebook en forum)": "Generate a sales ad for loose parts with AI (Marktplaats, Facebook, and forum)",
  "Genereer onderdelen": "Generate parts",
  "Genereer onderdelenlijst": "Generate parts list",
  "Genereren mislukt": "Generation failed",
  "Geopend": "Open",
  "Geopend?": "Open?",
  "Georgië": "Georgia",
  "Gepubliceerd": "Published",
  "Gepubliceerd in showroom!": "Published in showroom!",
  "Geregistreerde betalingen en openstaande facturen": "Registered payments and outstanding invoices",
  "Gereserveerd": "Reserved",
  "Gescand": "Scanned",
  "Geschatte arbeidstijd": "Estimated labor time",
  "Geschatte duur": "Estimated duration",
  "Geschatte staat": "Estimated status",
  "Geselecteerde onderdelen markeren als verkocht?": "Mark selected parts as sold?",
  "Geselecteerde onderdelen verwijderen?": "Remove selected parts?",
  "Gesloten": "Closed",
  "Gevonden": "Found",
  "Gevonden:": "Found:",
  "Geëxporteerd": "Exported",
  "Geüpload": "Uploaded",
  "Geüploade documenten worden automatisch gesynchroniseerd naar je cloud.": "Uploaded documents are automatically synced to your cloud.",
  "Gmail tip:": "Gmail tip:",
  "Goedkoop": "Low Cost",
  "Gratis": "Free",
  "Gratis accounts": "Free accounts",
  "Gratis instapplan": "Free Starter Plan",
  "Gratis pakketten, proefperiodes en promoties kunnen op ieder moment worden gewijzigd, beperkt of beëindigd.": "Free packages, trial periods, and promotions may be changed, limited, or terminated at any time.",
  "Gratis variant - upgrade voor onbeperkt gebruik en cloud sync.": "Free version - upgrade for unlimited use and cloud sync.",
  "Grootboek": "General Ledger",
  "Grootte": "Size",
  "Grote beurt + remblokken voor": "Major service + front brake pads",
  "HOOFD": "MAIN",
  "Haal RDW-gegevens op": "Retrieve RDW data",
  "Haal merk/model/APK op via RDW": "Retrieve make/model/MOT via RDW",
  "Haal merk/model/bouwjaar op via chassisnummer": "Retrieve make/model/year via VIN",
  "Hallo, ik heb interesse in:": "Hello, I am interested in:",
  "Handel in voorraad": "Trading Stock",
  "Handel verkocht": "Trading Stock Sold",
  "Handel: flip-calculatie per auto (kostprijs, netto marge, ROI% en dagen in voorraad) + afvinkbare RDW-titelchecklist": "Trade: flip calculation per car (cost price, net margin, ROI%, and days in stock) + tickable RDW title checklist",
  "Handelsvoorraad en verkochte voertuigen": "Trade stock and sold vehicles",
  "Handelvoorraad": "Trading Inventory",
  "Handtekening": "Signature",
  "Haïti": "Haiti",
  "Heb je al een account? Klik op \"Inloggen\" boven.": "Already have an account? Click \"Log In\" above.",
  "Heel jaar": "Full year",
  "Helaas": "Unfortunately",
  "Herhalen": "Repeat",
  "Herinnering": "Reminder",
  "Herinnering sturen": "Send reminder",
  "Herinnering verstuurd": "Reminder sent",
  "Herinnering verstuurd naar": "Reminder sent to",
  "Herinneringen nu versturen": "Send reminders now",
  "Herinneringen versturen na (dagen sinds factuurdatum):": "Send reminders after (days since invoice date):",
  "Herstellen": "Restore",
  "Het delen van accounts, licenties of toegangsgegevens met derden is niet toegestaan, tenzij dit uitdrukkelijk is toegestaan binnen het gekozen pakket.": "Sharing accounts, licenses, or access data with third parties is not permitted, unless expressly allowed within the chosen plan.",
  "Het is niet toegestaan beveiligingen te omzeilen.": "Bypassing security measures is not permitted.",
  "Het is niet toegestaan de dienst te misbruiken of schadelijke software te verspreiden.": "Misusing the service or distributing malicious software is not permitted.",
  "Het is niet toegestaan de software te reverse-engineeren.": "Reverse engineering the software is not permitted.",
  "Het is niet toegestaan onrechtmatige gegevens op te slaan of rechten van derden te schenden.": "Storing unlawful data or infringing upon third-party rights is not permitted.",
  "Het leveren en beveiligen van de dienst (uitvoering overeenkomst).": "Providing and securing the service (agreement execution).",
  "Het saldo = (winst% × totale omzet) + openstaande voorschotten. Als een voorschot verrekend wordt, gaat het van \"open\" naar \"verrekend\" en valt het uit het saldo.": "The balance = (profit% × total revenue) + outstanding advances. When an advance is settled, it changes from \"open\" to \"settled\" and is removed from the balance.",
  "Het versturen van afspraak-, herinnerings- en servicemails (uitvoering overeenkomst).": "Sending appointment, reminder, and service emails (agreement execution).",
  "Hobby modus": "Hobby Mode",
  "Hobby modus - geen BTW van toepassing": "Hobby Mode - no VAT applicable",
  "Hoe werkt activatie?": "How does activation work?",
  "Hoe werkt het?": "How does it work?",
  "Hoewel MonteurCentraal maatregelen neemt om gegevensverlies te voorkomen, wordt geen garantie gegeven dat gegevens nooit verloren gaan.": "While MonteurCentraal takes measures to prevent data loss, no guarantee is given that data will never be lost.",
  "Honderden monteurs werken dagelijks met MonteurCentraal": "Hundreds of mechanics work with MonteurCentraal daily",
  "Hoofd": "Main",
  "Hoofdvoertuig": "Main vehicle",
  "Hoog": "High",
  "Hostingprovider": "Hosting Provider",
  "Huidig wachtwoord": "Current password",
  "Huisnummer": "House number",
  "IBAN": "IBAN",
  "IP-adres": "IP address",
  "IP-adres, browser/apparaat, activiteitstijdstippen (voor beveiliging en het activatielogboek van je licentie).": "IP address, browser/device, activity timestamps (for security and your license's activation log).",
  "Ik heb al een licentiekey →": "I already have a license key →",
  "Importeer een MT940- of CAMT.053-afschrift en letter automatisch af tegen facturen en kosten": "Import an MT940 or CAMT.053 statement and automatically reconcile against invoices and expenses",
  "Importeer een bankafschrift (MT940 of CAMT.053) en letter automatisch af tegen openstaande facturen en kosten.": "Import a bank statement (MT940 or CAMT.053) and automatically reconcile it against outstanding invoices and expenses.",
  "In balans": "In balance",
  "In uitvoering": "In progress",
  "In voorraad": "In stock",
  "In voorraad — past op": "In stock — fits",
  "Incl. BTW": "Incl. VAT",
  "Indicatief overzicht op basis van je facturen en kosten. Raadpleeg je boekhouder voor de definitieve aangifte.": "Indicative overview based on your invoices and expenses. Consult your accountant for the final declaration.",
  "Indicatief overzicht op basis van je facturen, betalingen en kosten. Raadpleeg je boekhouder voor de definitieve aangifte en jaarrekening.": "Indicative overview based on your invoices, payments, and expenses. Consult your accountant for the final declaration and annual accounts.",
  "Indicatieve balans op basis van automatisch gegenereerde journaalposten. Voor de officiële jaarrekening: raadpleeg je boekhouder.": "Indicative balance based on automatically generated journal entries. For the official annual accounts: consult your accountant.",
  "Indicatieve marktprijs": "Indicative market price",
  "Indicatieve marktprijs, verkoopkans, verwachte winst en sterke/verbeterpunten": "Indicative market price, sales opportunity, expected profit, and strengths/areas for improvement",
  "Indonesië": "Indonesia",
  "Ingebouwd": "Built-in",
  "Ingekocht op": "Purchased on",
  "Ingetrokken": "Withdrawn",
  "Inkoop": "Purchase",
  "Inkoop, handel & extra AI-tools": "Purchasing, trade & extra AI tools",
  "Inkoopbron / leverancier": "Purchase source / supplier",
  "Inkoopbron/leverancier, retourstatus en garantie per onderdeel": "Purchase source/supplier, return status, and warranty per part",
  "Inkoopdatum": "Purchase date",
  "Inkooporder": "Purchase order",
  "Inkooporder (concept) aangemaakt": "Purchase order (draft) created",
  "Inkooporder ontvangen → vrije regels worden automatisch als nieuw voorraad-artikel aangemaakt (met OEM-nr en verkoopadvies)": "Purchase order received → free lines are automatically created as new stock items (with OEM number and recommended retail price)",
  "Inkooporder verwijderen?": "Delete purchase order?",
  "Inkooporders": "Purchase orders",
  "Inkoopprijs": "Purchase price",
  "Inlezen mislukt": "Import failed",
  "Inloggen": "Log in",
  "Inloggen mislukt": "Login failed",
  "Inruil voor handel A3": "Trade-in for trade A3",
  "Inschakelen": "Enable",
  "Installeer": "Install",
  "Installeren": "Installing",
  "Instellen": "Set up",
  "Instellingen": "Settings",
  "Instellingen opgeslagen": "Settings saved",
  "Instellingen → Licentie": "Settings → License",
  "Instellingen: licentie, cloud, team, SMTP en back-up op 1 plek": "Settings: license, cloud, team, SMTP, and backup in one place",
  "Intern (niet gefactureerd)": "Internal (not invoiced)",
  "Interval": "Interval",
  "Interval (km)": "Interval (km)",
  "Interval (maanden)": "Interval (months)",
  "Interval starttijden (min)": "Interval start times (min)",
  "Intrekken": "Revoke",
  "Invloed op waarde": "Impact on value",
  "Is er een proefperiode?": "Is there a trial period?",
  "Israël": "Israel",
  "Italië": "Italy",
  "JOUW LICENTIEKEY:": "YOUR LICENSE KEY:",
  "Ja": "Yes",
  "Ja. De maandpakketten zijn maandelijks opzegbaar. Bij een jaarpakket betaal je eenmalig en heb je twee maanden gratis ten opzichte van maandelijks.": "Yes. Monthly plans can be canceled monthly. With an annual plan, you pay once and get two months free compared to monthly payments.",
  "Ja. Je kunt op meerdere apparaten inloggen — Pro tot 10 actieve apparaten, Enterprise/Lifetime tot 50. Je beheert je apparaten zelf in de instellingen.": "Yes. You can log in on multiple devices — Pro up to 10 active devices, Enterprise/Lifetime up to 50. You manage your devices yourself in the settings.",
  "Jan de Vries": "Jan de Vries",
  "Januari–Februari 2026": "January–February 2026",
  "Je bent ingelogd, een moment...": "You are logged in, please wait...",
  "Je gegevens zijn van jou en worden per garage strikt gescheiden opgeslagen (AVG-proof). Met Pro of hoger kun je automatisch back-uppen naar Dropbox of Google Drive. Zie ook onze privacyverklaring.": "Your data is yours and is stored strictly separated per garage (GDPR-compliant). With Pro or higher, you can automatically back up to Dropbox or Google Drive. See also our privacy statement.",
  "Je hebt nog niet-opgeslagen wijzigingen. Weet je zeker dat je dit venster wilt verlaten?": "You have unsaved changes. Are you sure you want to leave this window?",
  "Je hebt recht op inzage, correctie, verwijdering, beperking en overdraagbaarheid van je persoonsgegevens, en het recht bezwaar te maken. Neem hiervoor contact op via": "You have the right to access, rectify, erase, restrict, and port your personal data, and the right to object. Please contact us via",
  "Je kunt Pro één maand proberen voor een tientje. Een proefperiode kan eenmalig per e-mailadres worden gebruikt.": "You can try Pro for one month for ten euros. A trial period can be used once per email address.",
  "Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.": "You can also file a complaint with the Dutch Data Protection Authority.",
  "Je licentie is verlopen — BASIC mode (gratis)": "Your license has expired — BASIC mode (free)",
  "Je licentie staat maximaal": "Your license allows a maximum of",
  "Je licentie verloopt binnenkort. Verleng op tijd om onderbreking te voorkomen.": "Your license is about to expire. Renew on time to prevent interruption.",
  "Je ontvangt na betaling een cryptografisch ondertekende licentiekey via e-mail.": "After payment, you will receive a cryptographically signed license key via email.",
  "Je publieke verkooppagina": "Your public sales page",
  "Je publieke verkooppagina met je occasions en onderdelen. Publiceer auto's/onderdelen onder": "Your public sales page with your used cars and parts. Publish cars/parts under",
  "Je publieke verkooppagina met je occasions en onderdelen. Publiceer auto\\'s/onderdelen onder": "Your public sales page with your used cars and parts. Publish cars/parts under",
  "Jordanië": "Jordan",
  "Journaalposten": "Journal entries",
  "Jouw boekingslink": "Your booking link",
  "Jouw gegevens": "Your data",
  "Jouw huidige plan": "Your current plan",
  "Jouw plan": "Your plan",
  "Jouw prijs": "Your price",
  "Juni 2026": "June 2026",
  "KM": "KM",
  "KM stand": "Mileage",
  "Kaapverdië": "Cape Verde",
  "Kan beter": "Could be better",
  "Kan camera niet starten": "Cannot start camera",
  "Kan straat + huisnummer niet lezen uit \"": "Cannot read street + house number from \"",
  "Kan straat + huisnummer niet uit \"": "Cannot read street + house number from \"",
  "Kenmerk": "Characteristic",
  "Kenteken": "License plate",
  "Kenteken (optioneel):": "License plate (optional):",
  "Kenteken + tot 6 foto's → AI herkent opties en schade en bepaalt de marktwaarde in één stap": "License plate + up to 6 photos → AI recognizes options and damage and determines market value in one step",
  "Kenteken invullen → AI maakt de advertentie, waardebepaling en foto-analyse.": "Enter license plate → AI creates the ad, valuation, and photo analysis.",
  "Kenteken is verplicht": "License plate is required",
  "Kenteken niet gevonden": "License plate not found",
  "Kenteken niet gevonden bij RDW": "License plate not found at RDW",
  "Kenteken opzoeken": "Look up license plate",
  "Kentekens": "License plates",
  "Kies": "Choose",
  "Kies bestand": "Choose file",
  "Kies datum & tijd": "Choose date & time",
  "Kies een betaling om te verwijderen": "Choose a payment to delete",
  "Kies een bon": "Choose a receipt",
  "Kies een klant": "Choose a customer",
  "Kies een kostenpost om te verwijderen": "Choose an expense to delete",
  "Kies een leverancier": "Choose a supplier",
  "Kies een sterk wachtwoord van minimaal 6 tekens.": "Choose a strong password of at least 6 characters.",
  "Kies een voertuig": "Choose a vehicle",
  "Kies een voertuig, typ het onderdeel en vergelijk de prijzen in 4 webshops": "Choose a vehicle, type the part, and compare prices in 4 webshops",
  "Kies het plan dat bij jouw garage past": "Choose the plan that suits your garage",
  "Kies het plan dat past bij jouw garage": "Choose the plan that fits your garage",
  "Kies kenteken": "Choose license plate",
  "Kies klant": "Choose customer",
  "Kies leverancier": "Choose supplier",
  "Kies locatie": "Choose location",
  "Kies of typ…": "Choose or type...",
  "Kies of vul een waarde in": "Choose or enter a value",
  "Kies onderdeel uit voorraad": "Choose part from stock",
  "Kilometerstand": "Mileage",
  "Kirgizië": "Kyrgyzstan",
  "Klaar om te plaatsen": "Ready to post",
  "Klaar om te plakken op Facebook": "Ready to post on Facebook",
  "Klaar voor Facebook Marketplace": "Ready for Facebook Marketplace",
  "Klaar voor Marktplaats": "Ready for Marktplaats",
  "Klaar voor ophalen": "Ready for pickup",
  "Klaarzetten voor Facebook Marketplace": "Prepare for Facebook Marketplace",
  "Klaarzetten voor Marktplaats": "Prepare for Marktplaats",
  "Klacht (optioneel)": "Complaint (optional)",
  "Klacht / uit te voeren werk": "Complaint / work to be performed",
  "Klant": "Customer",
  "Klant (optioneel):": "Customer (optional):",
  "Klant + voertuig automatisch aangemaakt of gekoppeld": "Customer + vehicle automatically created or linked",
  "Klant aanmaken (F1)": "Create customer (F1)",
  "Klant akkoord": "Customer approved",
  "Klant bewerken": "Edit customer",
  "Klant bijgewerkt": "Customer updated",
  "Klant heeft geen e-mailadres": "Customer has no email address",
  "Klant opgehaald": "Customer retrieved",
  "Klant opgeslagen": "Customer saved",
  "Klant terugbellen voor afspraak": "Call customer back for appointment",
  "Klant verwijderd": "Customer deleted",
  "Klant verwijderen?": "Delete customer?",
  "Klant- en voertuiggegevens (ingevoerd door de garage):": "Customer and vehicle details (entered by garage):",
  "Klant:": "Customer:",
  "Klanten": "Customers",
  "Klanten kunnen nu afspraken aanvragen.": "Customers can now request appointments.",
  "Klanten, voertuigen & voertuighistorie met RDW-kentekencheck en VIN-lookup (NHTSA)": "Customers, vehicles & vehicle history with RDW license plate check and VIN lookup (NHTSA)",
  "Klantenbeheer met voertuigen en historie": "Customer management with vehicles and history",
  "Klantnummer": "Customer number",
  "Kleinmateriaal": "Consumables",
  "Kleinmateriaal toevoegen": "Add consumables",
  "Kleur": "Color",
  "Klik om betalingen te bekijken/bewerken": "Click to view/edit payments",
  "Klik om status te wijzigen": "Click to change status",
  "Klik om status te wisselen": "Click to change status",
  "Klik om te verbinden": "Click to connect",
  "Klik op \"Betaling ontvangen\" zodra het bedrag (met het juiste kenmerk) op je rekening of PayPal staat. De licentiekey wordt dan automatisch gegenereerd en naar de klant gemaild.": "Click \"Payment received\" once the amount (with the correct reference) is in your account or PayPal. The license key will then be automatically generated and emailed to the customer.",
  "Klik op \"Betaling ontvangen\" zodra het bedrag met het juiste kenmerk op je rekening of PayPal staat. De licentiekey wordt dan automatisch gegenereerd en naar de klant gemaild.": "Click \"Payment received\" once the amount with the correct reference is in your account or PayPal. The license key will then be automatically generated and emailed to the customer.",
  "Klik op \"Opnieuw genereren\" om de foto's te analyseren.": "Click \"Regenerate\" to analyze the photos.",
  "Klik op \"Opnieuw genereren\" om de foto\\'s te analyseren.": "Click \"Regenerate\" to analyze the photos.",
  "Klik op 'Create API key' (volledig gratis) en kopieer de volledige sleutel — deze begint met AQ. of AIza…": "Click 'Create API key' (completely free) and copy the full key — it starts with AQ. or AIza…",
  "Klik op Opslaan om te bewaren.": "Click Save.",
  "Klik op de knop in de mail om je account te activeren.": "Click the button in the email to activate your account.",
  "Klik voor details": "Click for details",
  "Klik voor mutaties": "Click for changes",
  "Km bij laatste onderhoud": "Mileage at last service",
  "Km bij proefrit": "Mileage at test drive",
  "Km-stand": "Mileage",
  "Knoppen voor WhatsApp, bellen, e-mail en afspraak maken": "Buttons for WhatsApp, call, email, and make appointment",
  "Komt in": "Incoming",
  "Kon activiteit niet laden": "Could not load activity",
  "Kon data niet laden": "Could not load data",
  "Kon de boekingspagina niet laden.": "Could not load the booking page.",
  "Kon gratis accounts niet laden": "Could not load free accounts",
  "Kon het onderdeel niet goed herkennen — vul handmatig aan": "Could not properly recognize the part — complete manually",
  "Kon verrekenen niet laden": "Could not load reconciliation",
  "Kopieer": "Copy",
  "Kopieer alles": "Copy all",
  "Kopieer hele advertentie": "Copy entire ad",
  "Kopieer key": "Copy key",
  "Kopieer link": "Copy link",
  "Kopiëren": "Copy",
  "Koppel aan werkbon": "Link to work order",
  "Koppel sloopauto": "Link scrap car",
  "Koppelen aan": "Link to",
  "Koppeling": "Link",
  "Kort": "Short",
  "Korte samenvatting voor de klant": "Short summary for the customer",
  "Korting": "Discount",
  "Kortingscode opgeslagen": "Discount code saved",
  "Kortingscode verwijderen?": "Delete discount code?",
  "Kosten": "Costs",
  "Kosten & inkoopfacturen met automatische BTW": "Expenses & purchase invoices with automatic VAT",
  "Kosten (excl. BTW)": "Costs (excl. VAT)",
  "Kosten / Inkoopfacturen": "Costs / Purchase invoices",
  "Kosten / vervangen": "Costs / replace",
  "Kosten per categorie": "Costs per category",
  "Kosten €": "Costs €",
  "Kostenpost automatisch aangemaakt in Boekhouden": "Cost item automatically created in Accounting",
  "Kostenpost bewerken": "Edit cost item",
  "Kostenpost toegevoegd": "Cost item added",
  "Kostenpost toevoegen": "Add cost item",
  "Kostenpost verwijderd": "Cost item deleted",
  "Kostenpost verwijderen?": "Delete cost item?",
  "Kostprijs": "Cost price",
  "Kroatië": "Croatia",
  "KvK nummer": "Chamber of Commerce number",
  "Kwitantie": "Receipt",
  "Laag": "Low",
  "Laat klanten zelf afspraken aanvragen via een deelbare link.": "Allow customers to request appointments themselves via a shareable link.",
  "Laatst automatisch verstuurd voor": "Last automatically sent for",
  "Laatst bijgewerkt:": "Last updated:",
  "Laatst gefactureerd": "Last invoiced",
  "Laatst gezien": "Last seen",
  "Laatste activiteit": "Last activity",
  "Laatste bezoek": "Last visit",
  "Laatste cloud back-up:": "Last cloud backup:",
  "Laatste onderhoud": "Last maintenance",
  "Laatste run": "Last run",
  "Label afdrukken": "Print label",
  "Laden mislukt": "Loading failed",
  "Laden...": "Loading...",
  "Laden…": "Loading...",
  "Lage voorraad": "Low stock",
  "Landcode (wordt automatisch herkend bij +31, 0049, etc.)": "Country code (automatically recognized with +31, 0049, etc.)",
  "Lange tijd niet gezien": "Long time no see",
  "Layout opgeslagen": "Layout saved",
  "Let op:": "Please note:",
  "Let op: een VIN bevat geen kleur, kenteken of APK-datum. Bij Europese auto's kan het model beperkt gedecodeerd worden.": "Note: A VIN does not contain color, license plate, or MOT date. For European cars, the model may be decoded to a limited extent.",
  "Leverancier": "Supplier",
  "Leverancier bewerken": "Edit supplier",
  "Leverancier opgeslagen": "Supplier saved",
  "Leverancier verwijderd": "Supplier deleted",
  "Leverancier verwijderen?": "Delete supplier?",
  "Leveranciers": "Suppliers",
  "Libië": "Libya",
  "Licentie": "License",
  "Licentie deactiveren": "Deactivate license",
  "Licentie deactiveren? Cloud functies worden uitgeschakeld.": "Deactivate license? Cloud features will be disabled.",
  "Licentie geactiveerd! Cloud functies zijn nu beschikbaar.": "License activated! Cloud features are now available.",
  "Licentie gedeactiveerd": "License deactivated",
  "Licentie hersteld": "License restored",
  "Licentie herstellen en weer geldig maken?": "Reactivate license and make it valid again?",
  "Licentie ingetrokken": "License revoked",
  "Licentie status": "License status",
  "Licentie vereist": "License required",
  "Licentie vereist. Activeer eerst een PRO of ENTERPRISE licentie bij": "License required. First activate a PRO or ENTERPRISE license at",
  "Licentie verstuurd voor": "License sent for",
  "Licentie, cloud, team en back-up beheren": "Manage license, cloud, team, and backup",
  "Licentie:": "License:",
  "Licentiekey invoeren": "Enter license key",
  "Licenties worden cryptografisch ondertekend door MonteurCentraal en zijn niet te vervalsen.": "Licenses are cryptographically signed by MonteurCentraal and cannot be forged.",
  "Licenties worden geactiveerd nadat betaling is ontvangen.": "Licenses are activated after payment is received.",
  "Licenties zijn niet overdraagbaar zonder schriftelijke toestemming van MonteurCentraal.": "Licenses are not transferable without written permission from MonteurCentraal.",
  "Licenties, plannen & cloud": "Licenses, plans & cloud",
  "Licht": "Light",
  "Lijstweergave": "List view",
  "Linda de Groot": "Linda de Groot",
  "Link gekopieerd": "Link copied",
  "Live preview": "Live preview",
  "Locatie": "Location",
  "Locatie (bv. voorbumper L)": "Location (e.g. front bumper L)",
  "Locatie in magazijn": "Warehouse location",
  "Locatie is verplicht": "Location is required",
  "Locatie wijzigen": "Change location",
  "Log in of maak een account aan op": "Log in or create an account at",
  "Logisch voor bouwjaar": "Logical for year of manufacture",
  "Logo geüpload": "Logo uploaded",
  "Logo op de factuur is beschikbaar in <b>PRO</b> en <b>ENTERPRISE</b>. Activeer een licentie via <b>Instellingen → Plannen</b> om je eigen logo bovenaan offertes en facturen te tonen.": "Invoice logo is available in <b>PRO</b> and <b>ENTERPRISE</b>. Activate a license via <b>Settings → Plans</b> to display your own logo at the top of quotes and invoices.",
  "Logo op de factuur is beschikbaar in PRO en ENTERPRISE.": "Invoice logo is available in PRO and ENTERPRISE.",
  "Logo te groot (max 2 MB)": "Logo too large (max 2 MB)",
  "Logo tekst": "Logo text",
  "Logo uploaden": "Upload logo",
  "Logo vervangen": "Replace logo",
  "Logo verwijderd": "Logo removed",
  "Logo verwijderen": "Remove logo",
  "Logo verwijderen?": "Remove logo?",
  "Look up address via PDOK (postcode + house no.)": "Look up address via PDOK (postcode + house no.)",
  "Look up address via PDOK (street + house no. + city)": "Look up address via PDOK (street + house no. + city)",
  "MC-PRO-... (lange cryptografisch ondertekende key)": "MC-PRO-... (long cryptographically signed key)",
  "Maak advertentie": "Create ad",
  "Maak een deelfactuur (termijn/aanbetaling) voor": "Create a partial invoice (installment/down payment) for",
  "Maak een eerste klant + voertuig aan via": "Create your first customer + vehicle via",
  "Maak een publieke link aan zodat de klant op zijn telefoon de werkzaamheden kan goedkeuren en digitaal ondertekenen.": "Create a public link so the customer can approve the work and sign digitally on their phone.",
  "Maak hoofdfoto": "Set as main photo",
  "Maak hoofdvoertuig": "Set as main vehicle",
  "Maak inkooporder": "Create purchase order",
  "Maak je eerste werkbon of factuur via": "Create your first work order or invoice via",
  "Maak offerte-voorstel": "Create quote proposal",
  "Maak verkoopadvertentie": "Create sales ad",
  "Magazijnlabel": "Warehouse label",
  "Mail": "Mail",
  "Mail log": "Mail log",
  "Make / Model": "Make / Model",
  "Maleisië": "Malaysia",
  "Map openen": "Open folder",
  "Marge": "Margin",
  "Markeer als verrekend": "Mark as settled",
  "Markeer een voertuig (auto, scooter, motor, aanhanger…) en genereer automatisch een onderdelenlijst": "Mark a vehicle (car, scooter, motorcycle, trailer…) and automatically generate a parts list",
  "Markeer verkocht": "Mark as sold",
  "Markering": "Marking",
  "Marktconform": "Market conform",
  "Marktwaarde gebruikt": "Market value used",
  "Mary-Jane van der Berg": "Mary-Jane van der Berg",
  "Match": "Match",
  "Mauritanië": "Mauritania",
  "Max bonnen/mnd: ": "Max receipts/month:",
  "Max klanten": "Max customers",
  "Max teamleden": "Max team members",
  "Max. afspraken per tijdslot": "Max. appointments per time slot",
  "Max. appointments per time slot": "Max. appointments per time slot",
  "Medewerker": "Employee",
  "Medewerker toegevoegd": "Employee added",
  "Medewerker uitnodigen": "Invite employee",
  "Meer foto's toevoegen": "Add more photos",
  "Meer foto\\'s toevoegen": "Add more photos",
  "Meer zichtbaarheid en leads — zonder technische kennis.": "More visibility and leads — no technical knowledge required.",
  "Meertalig & internationaal bereik": "Multilingual & international reach",
  "Meertaligheid, online afspraken & boekhouding": "Multilingualism, online appointments & accounting",
  "Meest bekeken auto": "Most viewed car",
  "Meest bekeken onderdeel": "Most viewed part",
  "Meest verkocht": "Most sold",
  "Melding": "Notification",
  "Meldingen instellen": "Set up notifications",
  "Meldingen nu opnieuw genereren": "Regenerate notifications now",
  "Meldingen verversen": "Refresh notifications",
  "Meldingen worden automatisch elke nacht gegenereerd op basis van APK-datum, openstaande bonnen en geplande afspraken. Klik hieronder om ze handmatig nu te verversen.": "Notifications are automatically generated every night based on MOT due date, outstanding receipts, and scheduled appointments. Click below to refresh them manually now.",
  "Meldingen: open relevante klant, planning of document direct vanuit de lijst": "Notifications: open relevant customer, scheduling or document directly from the list",
  "Merk": "Make",
  "Merk / Model": "Make / Model",
  "Met postcode + huisnummer vullen we straat en plaats in": "With postcode + house number we fill in street and city",
  "Met straat + huisnummer + plaats vinden we de postcode": "With street + house number + city we find the postcode",
  "Met vriendelijke groet": "Sincerely",
  "Methode": "Method",
  "Mijn SMTP instellingen": "My SMTP settings",
  "Milieutoeslag": "Environmental surcharge",
  "Milieutoeslag toevoegen": "Add environmental surcharge",
  "Min": "Min",
  "Min voorraad": "Min stock",
  "Min.": "Min.",
  "Min. voorraad": "Min. stock",
  "Minimum voorraad met \"bijbestellen\"-waarschuwing + boekhoudkundige voorraadwaarde": "Minimum stock with \"reorder\" warning + accounting stock value",
  "Mislukt": "Failed",
  "Mister Auto": "Mister Auto",
  "Mobiele app & installeerbaar (PWA)": "Mobile app & installable (PWA)",
  "Model": "Model",
  "Model / Type": "Model / Type",
  "Mogelijk (naam komt overeen)": "Possible (name matches)",
  "Mogelijk gemaakt door": "Powered by",
  "Mogelijke OEM-alternatieven": "Possible OEM alternatives",
  "Moldavië": "Moldova",
  "Mongolië": "Mongolia",
  "Montage remblokken voor": "Front brake pad installation",
  "Monteur": "Mechanic",
  "MonteurCentraal (hierna \"wij\" of \"MonteurCentraal\") levert software waarmee autobedrijven hun administratie, planning en facturatie beheren.": "MonteurCentraal (hereinafter \"we\" or \"MonteurCentraal\") provides software that helps automotive businesses manage their administration, planning, and invoicing.",
  "MonteurCentraal Demo Garage": "MonteurCentraal Demo Garage",
  "MonteurCentraal behoudt zich het recht voor proefaccounts te weigeren of te beëindigen bij vermoedens van misbruik.": "MonteurCentraal reserves the right to refuse or terminate trial accounts in case of suspected abuse.",
  "MonteurCentraal biedt software voor onder andere klantenbeheer, voertuigbeheer, werkbonnen, offertes, facturen, boekhouding, planning, online afspraken, voorraadbeheer, onderdelenbeheer, handelauto’s, rapportages, cloudopslag en AI-functionaliteiten.": "MonteurCentraal offers software for customer management, vehicle management, work orders, quotes, invoices, accounting, planning, online appointments, stock management, parts management, trade cars, reports, cloud storage, and AI functionalities, among others.",
  "MonteurCentraal hecht veel waarde aan de bescherming van persoonsgegevens. In deze privacyverklaring leggen we uit welke gegevens we verwerken, waarom, en welke rechten je hebt. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).": "MonteurCentraal attaches great importance to the protection of personal data. In this privacy statement, we explain what data we process, why, and what rights you have. We process personal data in accordance with the General Data Protection Regulation (GDPR).",
  "MonteurCentraal is niet aansprakelijk voor indirecte schade, gevolgschade, omzetverlies, winstderving, bedrijfsschade, verlies van klanten, verlies van gegevens, fiscale schade, naheffingen, boetes, gemiste afspraken, onjuiste berekeningen, onjuiste AI-resultaten, onjuiste voertuiggegevens, onjuiste kentekengegevens, fouten van externe diensten of gebruikersfouten.": "MonteurCentraal is not liable for indirect damage, consequential damage, loss of turnover, loss of profit, business damage, loss of customers, loss of data, fiscal damage, additional assessments, fines, missed appointments, incorrect calculations, incorrect AI results, incorrect vehicle data, incorrect license plate data, errors of external services or user errors.",
  "MonteurCentraal is niet aansprakelijk voor tekortkomingen veroorzaakt door overmacht, waaronder internetstoringen, stroomuitval, cyberaanvallen, DDoS-aanvallen, storingen bij cloudproviders, storingen bij AI-diensten, storingen bij betaalproviders, overheidsmaatregelen, natuurrampen, oorlog of arbeidsconflicten.": "MonteurCentraal is not liable for shortcomings caused by force majeure, including internet disruptions, power outages, cyber attacks, DDoS attacks, disruptions at cloud providers, disruptions at AI services, disruptions at payment providers, government measures, natural disasters, war, or labor disputes.",
  "MonteurCentraal is niet verantwoordelijk voor fouten, vertragingen, wijzigingen of storingen bij dergelijke externe partijen.": "MonteurCentraal is not responsible for errors, delays, changes, or disruptions by such external parties.",
  "MonteurCentraal is nu installeerbaar als app op telefoon, tablet en pc (\"Zet op beginscherm\")": "MonteurCentraal is now installable as an app on phone, tablet and PC (\"Add to Home Screen\")",
  "MonteurCentraal kan accounts opschorten of beëindigen bij wanbetaling, fraude, misbruik, overtreding van deze voorwaarden of beveiligingsrisico’s.": "MonteurCentraal may suspend or terminate accounts for non-payment, fraud, abuse, violation of these terms, or security risks.",
  "MonteurCentraal kan gebruikmaken van AI-functionaliteiten, waaronder advertentiegeneratie, documentherkenning, kentekenbewijsherkenning, voertuigherkenning, onderdelenherkenning, tekstgeneratie, analyses en suggesties.": "MonteurCentraal may use AI functionalities, including ad generation, document recognition, license plate recognition, vehicle recognition, part recognition, text generation, analyses, and suggestions.",
  "MonteurCentraal kan gegevens ophalen of verwerken via externe diensten zoals RDW, PDOK, Dropbox, Google Drive, e-mailproviders, AI-diensten, hostingproviders en betaaldiensten.": "MonteurCentraal may retrieve or process data via external services such as RDW, PDOK, Dropbox, Google Drive, email providers, AI services, hosting providers, and payment services.",
  "MonteurCentraal levert de dienst op basis van een inspanningsverplichting.": "MonteurCentraal provides the service based on a best-effort obligation.",
  "MonteurCentraal mag accounts blokkeren of verwijderen bij misbruik, fraude, spam, beveiligingsrisico’s of overtreding van deze voorwaarden.": "MonteurCentraal may block or delete accounts in case of abuse, fraud, spam, security risks or violation of these terms.",
  "MonteurCentraal mag deze voorwaarden op ieder moment wijzigen. De meest actuele versie wordt gepubliceerd op de website.": "MonteurCentraal may change these terms at any time. The most current version will be published on the website.",
  "MonteurCentraal mag technische maatregelen treffen ter bescherming van licenties, gebruikersaantallen en apparaten.": "MonteurCentraal may take technical measures to protect licenses, user numbers and devices.",
  "MonteurCentraal may retrieve or process data via external services such as RDW, PDOK, Dropbox, Google Drive, email providers, AI services, hosting providers, and payment services.": "MonteurCentraal may retrieve or process data via external services such as RDW, PDOK, Dropbox, Google Drive, email providers, AI services, hosting providers, and payment services.",
  "MonteurCentraal streeft naar een zo hoog mogelijke beschikbaarheid, maar geeft geen garantie op foutloze werking, continue beschikbaarheid of afwezigheid van storingen.": "MonteurCentraal strives for the highest possible availability, but does not guarantee faultless operation, continuous availability or absence of disruptions.",
  "MonteurCentraal:": "MonteurCentraal:",
  "Monteursnotities (intern)": "Technician Notes (internal)",
  "Motor": "Engine",
  "Motor / inhoud": "Engine / displacement",
  "Multi-tenant: elk garagebedrijf volledig gescheiden, multi-user met eigen rollen": "Multi-tenant: each garage fully separated, multi-user with individual roles",
  "N.v.t.": "N/A",
  "Na je betaling ontvang je automatisch een licentiekey per e-mail. Log in, ga naar Instellingen → Licentie, plak de key en klik op activeren. Je bent meteen klaar.": "After payment, you will automatically receive a license key via email. Log in, go to Settings → License, paste the key and click activate. You're ready to go.",
  "Na korting": "After discount",
  "Naam": "Name",
  "Naam (in eigen taal)": "Name (original language)",
  "Naam is verplicht": "Name is required",
  "Naam van de dienst": "Service name",
  "Naar bon": "To receipt",
  "Naar inloggen →": "To login →",
  "Nachtelijk": "Nightly",
  "Namibië": "Namibia",
  "Nee": "No",
  "Negeren": "Ignore",
  "Netto marge": "Net margin",
  "New: \"Share\" button in the showroom — share your used cars in one tap via WhatsApp or copy the link": "New: \"Share\" button in the showroom — share your used cars in one tap via WhatsApp or copy the link",
  "Niemand": "None",
  "Niet akkoord": "Disagree",
  "Niet geactiveerd": "Not activated",
  "Niet geconfigureerd": "Not configured",
  "Niet gestart": "Not started",
  "Niet in balans — werk de boekhouding bij": "Out of balance — update accounting",
  "Niet ingesteld": "Not set",
  "Nieuw document": "New document",
  "Nieuw inkoop": "New purchase",
  "Nieuw onderdeel": "New part",
  "Nieuw onderdeel aanmaken met code": "Create new part with code",
  "Nieuw verkoop": "New sale",
  "Nieuw voertuig": "New vehicle",
  "Nieuw voorschot": "New advance payment",
  "Nieuw wachtwoord": "New password",
  "Nieuw wachtwoord instellen": "Set new password",
  "Nieuw: \"Deel\"-knop in de showroom — deel je occasions in één tik via WhatsApp of kopieer de link": "New: \"Share\" button in the showroom — share your used cars in one tap via WhatsApp or copy the link",
  "Nieuw: AI Foutcode-uitleg (OBD/DTC → oorzaken, onderdelen, arbeidstijd)": "New: AI Fault Code Explanation (OBD/DTC → causes, parts, labor time)",
  "Nieuw: AI Offerte-assistent (klacht → kant-en-klare offerteregels met richtprijzen)": "New: AI Quote Assistant (complaint → ready-made quote lines with indicative prices)",
  "Nieuw: knop \"Plaats op Facebook\" — kopieert titel + tekst, downloadt je foto's en opent Facebook Marketplace (veilig plakken, geen API-risico)": "New: \"Post to Facebook\" button — copies title + text, downloads your photos and opens Facebook Marketplace (safe paste, no API risk)",
  "Nieuwe APK": "New MOT",
  "Nieuwe afspraak": "New appointment",
  "Nieuwe auto": "New car",
  "Nieuwe banden": "New tires",
  "Nieuwe bon": "New receipt",
  "Nieuwe claim": "New claim",
  "Nieuwe diagnose": "New diagnosis",
  "Nieuwe factuur": "New invoice",
  "Nieuwe garantieclaim": "New warranty claim",
  "Nieuwe handel auto": "New trade-in vehicle",
  "Nieuwe inkooporder": "New purchase order",
  "Nieuwe klant": "New customer",
  "Nieuwe klant aanmaken": "Create new customer",
  "Nieuwe klant wordt aangemaakt": "New customer is being created",
  "Nieuwe leverancier": "New supplier",
  "Nieuwe melding": "New notification",
  "Nieuwe module \"APK & Onderhoud\" met APK-vervalwaarschuwingen (verlopen / binnenkort) per voertuig": "New \"MOT & Maintenance\" module with MOT expiry warnings (expired / soon) per vehicle",
  "Nieuwe online aanvragen": "New online requests",
  "Nieuwe planning": "New schedule",
  "Nieuwe remmen": "New brakes",
  "Nieuwe taal toevoegen": "Add new language",
  "Nieuwe werkbon": "New work order",
  "Nieuwe werkorder": "New work order",
  "Nieuwprijs": "New price",
  "No hidden costs. Upgrade or downgrade anytime via your license key.": "No hidden costs. Upgrade or downgrade anytime via your license key.",
  "No license plate? Upload a photo of the vehicle documents (also foreign, e.g. German) — the AI will fill in make, model, year of manufacture, etc.": "No license plate? Upload a photo of the vehicle documents (also foreign, e.g. German) — the AI will fill in make, model, year of manufacture, etc.",
  "Nog geen": "None yet",
  "Nog geen account? Klik op \"Account aanmaken\" boven.": "No account yet? Click \"Create account\" above.",
  "Nog geen activaties op deze licentie.": "No activations yet on this license.",
  "Nog geen activiteit geregistreerd.": "No activity registered yet.",
  "Nog geen alternatieve nummers": "No alternative numbers yet",
  "Nog geen bandensets opgeslagen": "No tire sets saved yet",
  "Nog geen bestellingen.": "No orders yet.",
  "Nog geen betalingen geregistreerd voor deze bon.": "No payments registered yet for this receipt.",
  "Nog geen bonnen geregistreerd voor dit voertuig.": "No receipts registered yet for this vehicle.",
  "Nog geen bonnen.": "No receipts yet.",
  "Nog geen cloud gekoppeld. Ga naar": "No cloud linked yet. Go to",
  "Nog geen controlepunten": "No checkpoints yet",
  "Nog geen e-mails verstuurd.": "No emails sent yet.",
  "Nog geen garantieclaims.": "No warranty claims yet.",
  "Nog geen gebeurtenissen": "No events yet",
  "Nog geen geregistreerde apparaten.": "No registered devices yet.",
  "Nog geen herinneringen verstuurd.": "No reminders sent yet.",
  "Nog geen inkooporders.": "No purchase orders yet.",
  "Nog geen journaalposten. Klik op \"Bijwerken\" om automatisch te boeken uit je facturen, betalingen en kosten.": "No journal entries yet. Click \"Update\" to automatically post from your invoices, payments, and expenses.",
  "Nog geen klant-omzet geregistreerd.": "No customer revenue registered yet.",
  "Nog geen kortingscodes opgeslagen.": "No discount codes saved yet.",
  "Nog geen kosten geregistreerd. Klik op \"Kostenpost toevoegen\" om je eerste inkoopfactuur in te voeren.": "No expenses registered yet. Click \"Add Expense Item\" to enter your first purchase invoice.",
  "Nog geen kostenposten. Klik": "No expense items yet. Click",
  "Nog geen kostenposten. Klik + Toevoegen om bijvoorbeeld een vervangen onderdeel of voorgeschoten kosten te registreren.": "No expense items yet. Click + Add to register, for example, a replaced part or advanced costs.",
  "Nog geen leveranciers. Voeg je eerste leverancier toe.": "No suppliers yet. Add your first supplier.",
  "Nog geen licentie? Bekijk onze pakketten": "No license yet? View our packages",
  "Nog geen locaties toegevoegd.": "No locations added yet.",
  "Nog geen omzet geregistreerd.": "No revenue registered yet.",
  "Nog geen omzet geregistreerd. Maak je eerste factuur of werkbon aan om hier de grafiek te zien.": "No revenue registered yet. Create your first invoice or work order to see the graph here.",
  "Nog geen omzet geregistreerd. Zodra je facturen of werkbonnen aanmaakt verschijnt hier de grafiek.": "No revenue registered yet. As soon as you create invoices or work orders, the graph will appear here.",
  "Nog geen onderdelen. Voeg er een toe of genereer ze vanuit een sloopauto.": "No parts yet. Add one or generate them from a salvage car.",
  "Nog geen regels.": "No lines yet.",
  "Nog geen showroom-link. Publiceer eerst een auto of onderdeel in je showroom — daarna verschijnt hier je persoonlijke link.": "No showroom link yet. First publish a car or part in your showroom — then your personal link will appear here.",
  "Nog geen sloopauto's toegevoegd.": "No scrap cars added yet.",
  "Nog geen sloopauto\\'s toegevoegd.": "No salvage cars added yet.",
  "Nog geen terugroepacties. Voeg een recall toe; het systeem markeert automatisch de getroffen voertuigen in je klantenbestand.": "No recalls yet. Add a recall; the system will automatically mark affected vehicles in your customer database.",
  "Nog geen verkochte onderdelen.": "No parts sold yet.",
  "Nog geen verkopen geregistreerd.": "No sales registered yet.",
  "Nog geen werkplekken": "No workstations yet",
  "Nog niets gepubliceerd. Maak een advertentie en klik op \"Publiceer in showroom\".": "Nothing published yet. Create an ad and click \"Publish to showroom\".",
  "Nog nodig voor break-even": "Still needed for break-even",
  "Nog te betalen": "Still to be paid",
  "Nog te voldoen": "Still due",
  "Noord-Macedonië": "North Macedonia",
  "Note: a VIN does not contain colour, license plate or MOT date. For European cars the model may be only partially decoded.": "Note: a VIN does not contain colour, license plate or MOT date. For European cars the model may be only partially decoded.",
  "Notitie": "Note",
  "Nu verlengen →": "Renew now →",
  "Nummer": "Number",
  "O-2025-0079 voor Jan de Vries": "Q-2025-0079 for Jan de Vries",
  "OAuth start mislukt": "OAuth start failed",
  "OEM": "OEM",
  "OEM cross-reference (alternatieve nummers)": "OEM cross-reference (alternative numbers)",
  "OEM nummer": "OEM number",
  "OFFERTE": "QUOTE",
  "OK": "OK",
  "OPENSTAAND": "OUTSTANDING",
  "Occasion- en onderdeel-detailpagina met WhatsApp, bellen, e-mail en afspraak": "Used car and part detail page with WhatsApp, call, email and appointment options",
  "Occasions": "Used Cars",
  "Occasions én onderdelen met foto's, specs en AI-tekst": "Used cars and parts with photos, specs and AI text",
  "Oekraïne": "Ukraine",
  "Of vul handmatig in": "Or enter manually",
  "Offerte": "Quote",
  "Offertes": "Quotes",
  "Offertes, werkbonnen en facturen": "Quotes, work orders and invoices",
  "Offline": "Offline",
  "Offline - wijzigingen worden lokaal bewaard": "Offline - changes are saved locally",
  "Offline gehaald": "Taken offline",
  "Offline halen": "Take offline",
  "Om de hoeveel minuten een afspraak kan starten (bijv. 30).": "Appointment start interval (e.g. 30 minutes).",
  "Omgezet naar": "Converted to",
  "Omschrijving": "Description",
  "Omschrijving (bijv. 10% korting)": "Description (e.g. 10% discount)",
  "Omschrijving / vervangen": "Description / Replace",
  "Omschrijving is verplicht": "Description is required",
  "Omzet (excl. BTW)": "Revenue (excl. VAT)",
  "Omzet (excl.)": "Revenue (excl.)",
  "Omzet deze maand": "Revenue this month",
  "Omzet dit jaar": "Revenue this year",
  "Omzet per maand (€) - laatste 12 mnd": "Monthly revenue (€) - last 12 months",
  "Omzet vandaag": "Revenue today",
  "Omzetten mislukt": "Conversion failed",
  "Onbekend": "Unknown",
  "Onbekend apparaat": "Unknown device",
  "Onbekende klant": "Unknown customer",
  "Onbeperkt": "Unlimited",
  "Onbetaalde facturen": "Unpaid invoices",
  "Once your payment is received, you will automatically receive your license key via email at": "Once your payment is received, you will automatically receive your license key via email at",
  "Onder marktprijs — snelle verkoop": "Below market price — quick sale",
  "Onder minimum": "Below minimum",
  "Onderdeel": "Part",
  "Onderdeel bewerken": "Edit part",
  "Onderdeel binnengekomen": "Part received",
  "Onderdeel gevonden": "Part found",
  "Onderdeel herkend — gegevens ingevuld": "Part recognized — details filled",
  "Onderdeel niet in deze lijst": "Part not in this list",
  "Onderdeel opgeslagen": "Part saved",
  "Onderdeel toevoegen": "Add part",
  "Onderdeel uit voorraad": "Part from stock",
  "Onderdeel verkopen": "Sell part",
  "Onderdeel verwijderd": "Part deleted",
  "Onderdeel verwijderen?": "Delete part?",
  "Onderdeel-advertenties (AI)": "Part ads (AI)",
  "Onderdeelnaam": "Part name",
  "Onderdeelnr": "Part No.",
  "Onderdeelnummer": "Part number",
  "Onderdelen": "Parts",
  "Onderdelen / kosten": "Parts / costs",
  "Onderdelen besteld": "Parts ordered",
  "Onderdelen gegenereerd": "Parts generated",
  "Onderdelen genereren": "Generate parts",
  "Onderdelen publiceren vanuit de voorraad": "Publish parts from stock",
  "Onderdelen-catalogus": "Parts catalog",
  "Onderdelen: import uit bonnen, bewerk voorraad en filter direct in dit scherm": "Parts: import from receipts, edit stock and filter directly on this screen",
  "Onderdelenhandel": "Parts Trade",
  "Onderdelenhandel Pro": "Parts Trade Pro",
  "Onderdelenhandel — beheer, waardeer en verkoop onderdelen": "Parts trade — manage, value, and sell parts",
  "Onderdelenkaart met OEM/nummer, conditie, locatie, prijzen en foto's": "Part card with OEM/number, condition, location, prices, and photos",
  "Onderhoud": "Maintenance",
  "Onderhoudshistorie": "Maintenance History",
  "Onderhoudsinterval": "Maintenance Interval",
  "Onderhoudsinterval per auto (maanden + km) met automatische berekening van de volgende beurt": "Maintenance interval per car (months + km) with automatic calculation of next service",
  "Onderhoudswerkzaamheden mogen zonder voorafgaande aankondiging worden uitgevoerd.": "Maintenance work may be carried out without prior notice.",
  "Onderwerp": "Subject",
  "Ongeldig JSON-bestand": "Invalid JSON file",
  "Ongeldig bedrag": "Invalid amount",
  "Online": "Online",
  "Online aanvraag": "Online request",
  "Online afspraken": "Online Appointments",
  "Online afspraken zijn niet (meer) beschikbaar voor deze garage.": "Online appointments are not (or no longer) available for this garage.",
  "Online afspraken — boekingslink": "Online Appointments — Booking link",
  "Online afspraken: publieke boekingspagina (monteurcentraal.com/afspraak/jouw-garage) met diensten, tijdsloten en RDW-check": "Online appointments: public booking page (monteurcentraal.com/afspraak/your-garage) with services, time slots and RDW check",
  "Online booking is not (or no longer) available for this garage.": "Online booking is not (or no longer) available for this garage.",
  "Online gezet": "Set online",
  "Online in showroom — klik om offline te halen": "Online in showroom — click to take offline",
  "Online zetten": "Set online",
  "Ontgrendel de volledige boekhouding": "Unlock full accounting",
  "Ontvangen": "Received",
  "Ontvangen betalingen": "Payments Received",
  "Ontvangst bevestigen": "Confirm receipt",
  "Ontvangst boeken": "Book receipt",
  "Op deze voorwaarden is uitsluitend Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.": "These terms and conditions are governed exclusively by Dutch law. Disputes shall be submitted to the competent court in the Netherlands.",
  "Op voorraad": "In stock",
  "Open": "Open",
  "Open alle 4": "Open all 4",
  "Open documenten van": "Open documents from",
  "Open facturen": "Open Invoices",
  "Open in Bonnen": "Open in Receipts",
  "Open klant": "Open customer",
  "Open planning": "Open scheduling",
  "Open voorschot": "Open advance payment",
  "Open werk en lopende reparaties": "Open work and ongoing repairs",
  "Open werkorders": "Open Work Orders",
  "Openen": "Open",
  "Openingstijden": "Opening Hours",
  "Openstaand": "Outstanding",
  "Openstaand bedrag": "Outstanding amount",
  "Openstaande bonnen": "Outstanding Receipts",
  "Openstaande facturen, ouderdomsanalyse (aging) en betalingsherinneringen": "Outstanding invoices, aging analysis and payment reminders",
  "Openstaande facturen, ouderdomsanalyse (aging) en betalingsherinneringen versturen": "Outstanding invoices, aging analysis and send payment reminders",
  "Openstaande orders": "Outstanding Orders",
  "Opgehaald": "Picked up",
  "Opgeslagen": "Saved",
  "Opgeslagen als concept": "Saved as draft",
  "Opgesteld": "Generated",
  "Opmerkingen": "Notes",
  "Opnieuw genereren": "Regenerate",
  "Opnieuw opbouwen": "Rebuild",
  "Opnieuw opgebouwd": "Rebuilt",
  "Opnieuw versturen": "Resend",
  "Opnieuw versturen mislukt": "Resend failed",
  "Oproep-tekst (CTA)": "Call to action (CTA)",
  "Opslaan": "Save",
  "Opslaan & werkbon maken": "Save & create work order",
  "Opslaan als concept": "Save as draft",
  "Opslaan mislukt": "Save failed",
  "Opslaglocatie": "Storage location",
  "Optie 1 — Bankoverschrijving": "Option 1 — Bank transfer",
  "Optie 2 — PayPal": "Option 2 — PayPal",
  "Opzoeken": "Lookup",
  "Order annuleren?": "Cancel order?",
  "Order besteld": "Order placed",
  "Order opgeslagen": "Order saved",
  "Orders": "Orders",
  "Origineel rapport bewaard bij de documenten": "Original report saved with documents",
  "Oud inkoop": "Previous purchases",
  "Oud verkoop": "Previous sales",
  "Ouderdomsanalyse (aging)": "Aging analysis",
  "Oudste": "Oldest",
  "Over ons": "About us",
  "Overview of your garage": "Overview of your garage",
  "Overzicht van uw garage": "Overview of your garage",
  "PDF": "PDF",
  "PDF beheer en cloud-synchronisatie": "PDF management and cloud synchronization",
  "PDOK lookup mislukt": "PDOK lookup failed",
  "PNG of JPG, max 2 MB. Wordt links bovenaan getoond op je bonnen (vervangt de tekstlogo).": "PNG or JPG, max 2 MB. Shown at the top left of your receipts (replaces the text logo).",
  "PNG, JPG, SVG, WebP · max 2 MB": "PNG, JPG, SVG, WebP · max 2 MB",
  "POPULAIR": "POPULAR",
  "Pagina": "Page",
  "Pakket": "Package",
  "Pas de opmaak van offertes en facturen aan": "Customize the layout of quotes and invoices",
  "Pas de uitstraling van je publieke showroom én boekingspagina aan. Je logo stel je in onder Bon layout.": "Customize the appearance of your public showroom and booking page. Your logo can be set under Receipt layout.",
  "Passiva (schulden & vermogen)": "Liabilities (debts & equity)",
  "Past ook op": "Also fits",
  "Past op": "Fits",
  "Past op voertuigen": "Fits vehicles",
  "Past-op lijst (merk/model/bouwjaar) en OEM cross-reference (alternatieve nummers)": "Fits-on list (make/model/year) and OEM cross-reference (alternative numbers)",
  "Paste this into the License tab to activate your plan immediately. The license will be tied to your garage and cannot be reused by others.": "Paste this into the License tab to activate your plan immediately. The license will be tied to your garage and cannot be reused by others.",
  "Pay via PayPal": "Pay via PayPal",
  "Pay via bank transfer or PayPal · License key automatically emailed after payment is received": "Pay via bank transfer or PayPal · License key automatically emailed after payment is received",
  "Per page": "Per page",
  "Per pagina": "Per page",
  "Percentage (%)": "Percentage (%)",
  "Perfect voor slopers, onderdelenhandelaren en hobbygarages.": "Perfect for dismantlers, parts dealers and hobby garages.",
  "Periode": "Period",
  "Persoon": "Person",
  "Plaats": "City",
  "Plaats op Facebook": "Post on Facebook",
  "Plaats uw handtekening.": "Place your signature.",
  "Plak de key en klik": "Paste the key and click",
  "Plak de sleutel hieronder en klik op Opslaan. We testen hem meteen voordat we hem (versleuteld) bewaren.": "Paste the key below and click Save. We'll test it immediately before storing it (encrypted).",
  "Plak de tekst en voeg de foto's toe.": "Paste the text and add the photos.",
  "Plak de tekst en voeg de foto\\'s toe.": "Paste the text and add the photos.",
  "Plak deze in het Licentie tabblad om je plan direct te activeren. De licentie wordt gebonden aan jouw garage en kan niet hergebruikt worden door anderen.": "Paste this into the License tab to activate your plan immediately. The license will be tied to your garage and cannot be reused by others.",
  "Plan": "Plan",
  "Plan afspraak": "Schedule appointment",
  "Plan seizoenswissel": "Schedule seasonal change",
  "Planning vandaag": "Today's schedule",
  "Pluspunten & onderhoud": "Pros & Maintenance",
  "Pluspunten & onderhoud (distributieriem, nieuwe APK/banden/remmen, sleutels, onderhoudshistorie) worden in de tekst verwerkt": "Pros & maintenance (timing belt, new MOT/tires/brakes, keys, maintenance history) are included in the text",
  "Pop-up geblokkeerd": "Pop-up blocked",
  "Popup geblokkeerd - sta popups toe voor deze site": "Pop-up blocked - allow pop-ups for this site",
  "Postcode": "Postal code",
  "Postcode (1011 AA)": "Postal code (1011 AA)",
  "Postcode / Plaats": "Postal code / City",
  "Preview Marktplaats": "Marketplace Preview",
  "Pricing-tiers (Basic / Pro / Enterprise / Lifetime) met onkraakbare cryptografische licenties": "Pricing tiers (Basic / Pro / Enterprise / Lifetime) with unbreakable cryptographic licenses",
  "Prijs": "Price",
  "Prijs (€)": "Price (€)",
  "Prijs hoog → laag": "Price high → low",
  "Prijs laag → hoog": "Price low → high",
  "Prijsadvies mislukt": "Price suggestion failed",
  "Prijsanalyse": "Price analysis",
  "Prijshistorie": "Price History",
  "Prijsvergelijk onderdelen": "Parts Price Comparison",
  "Prijswijzigingen kunnen op ieder moment worden doorgevoerd voor toekomstige periodes.": "Price changes can be implemented at any time for future periods.",
  "Prijzen staan vermeld op de website.": "Prices are listed on the website.",
  "Print PDF": "Print PDF",
  "Printed via MonteurCentraal": "Printed via MonteurCentraal",
  "Prioriteit": "Priority",
  "Privacyverklaring": "Privacy Policy",
  "Proefrit gemaakt": "Test Drive Taken",
  "Professionele facturatie": "Professional Invoicing",
  "Profiel": "Profile",
  "Profieldiepte (mm)": "Tread Depth (mm)",
  "Profit distribution per team member": "Profit distribution per team member",
  "Profit share per team member + advance costs": "Profit share per team member + advance costs",
  "Provide a valid language code (e.g. de)": "Provide a valid language code (e.g. de)",
  "Publiceer": "Publish",
  "Publiceer auto's en onderdelen met één klik naar je eigen verkooppagina — geen webshop of hosting nodig.": "Publish cars and parts with one click to your own sales page — no webshop or hosting needed.",
  "Publiceer in showroom": "Publish in Showroom",
  "Publiceren mislukt": "Publish Failed",
  "Publieke Showroom": "Public Showroom",
  "Publieke akkoord-link": "Public Approval Link",
  "Publieke showroom": "Public Showroom",
  "Publieke showroom & boekingspagina herkennen automatisch de taal van je bezoeker (Nederlands, Engels, Duits) en tonen de site meteen in de juiste taal": "Public showroom & booking page automatically detect your visitor's language (Dutch, English, German) and show the site in the right language right away",
  "QR-label": "QR Label",
  "QR-magazijnlabels per onderdeel (afdrukken) + onderdeel terugvinden via camera-scan": "QR warehouse labels per part (print) + find part via camera scan",
  "RDW check": "RDW Check",
  "RDW gevonden": "RDW Found",
  "RDW kenteken check": "RDW License Plate Check",
  "RDW lookup mislukt": "RDW Lookup Failed",
  "RDW mislukt": "RDW Failed",
  "RDW ophalen": "Retrieve RDW",
  "RDW opzoeken": "RDW Lookup",
  "RDW-data + APK automatisch in de tekst, indicatieve marktprijs & vraagprijs-meter": "RDW data + MOT automatically in the text, indicative market price & asking price meter",
  "RDW-data inbegrepen — APK-datum staat automatisch in de tekst": "RDW data included — MOT date automatically in the text",
  "RDW-kentekencheck al ingebouwd in het formulier": "RDW license plate check already built into the form",
  "RDW-titelchecklist": "RDW Title Checklist",
  "Rapport (PDF)": "Report (PDF)",
  "Rapport geëxporteerd": "Report Exported",
  "Rapport naar boekhouder": "Report to Accountant",
  "Rapport verstuurd": "Report Sent",
  "Rapportage: kies periode, filters en exporteer daarna de uitkomst": "Report: select period, filters and then export the result",
  "Reactie ontvangen": "Response Received",
  "Recalls": "Recalls",
  "Recent onderhoud verhoogt de marktwaarde met": "Recent maintenance increases market value by",
  "Recent onderhouden": "Recently Serviced",
  "Recente activiteit": "Recent Activity",
  "Reden intrekking:": "Reason for Revocation:",
  "Reden voor het intrekken van licentie": "Reason for License Revocation",
  "Reeds akkoord gegeven door": "Already approved by",
  "Reeds betaald": "Already Paid",
  "Referentie": "Reference",
  "Regel toevoegen": "Add Row",
  "Regels": "Line Items",
  "Registratie mislukt": "Registration Failed",
  "Registreer je uitgaven en inkoopfacturen voor je boekhouding en BTW-aangifte": "Record your expenses and purchase invoices for your accounting and VAT declaration",
  "Registreer uitgaven en inkoopfacturen voor je boekhouding en BTW-aangifte": "Register expenses and purchase invoices for your accounting and VAT return",
  "Registreren": "Register",
  "Rekening": "Account",
  "Remblokken voor (set)": "Front brake pads (set)",
  "Remblokken voor Volkswagen Golf": "Front brake pads for Volkswagen Golf",
  "Reparatie-historie": "Repair History",
  "Reparaties": "Repairs",
  "Reservering klant Bakker tot 15-07": "Customer reservation Bakker until 15-07",
  "Reset": "Reset",
  "Reset mislukt": "Reset Failed",
  "Reset-link versturen": "Send Reset Link",
  "Reset-mail verstuurd": "Reset Email Sent",
  "Resultaat": "Result",
  "Resultaat (winst/verlies)": "Result (profit/loss)",
  "Resultaat boekjaar": "Fiscal year result",
  "Retourstatus": "Return status",
  "Retrieve make/model/MOT via RDW": "Retrieve make/model/MOT via RDW",
  "Retrieve make/model/year via VIN": "Retrieve make/model/year via VIN",
  "Revenue per month (€) - last 12 mo": "Revenue per month (€) - last 12 mo",
  "Richt de camera op een QR- of streepjescode": "Point the camera at a QR or barcode",
  "Richtprijs": "Indicative price",
  "Roemenië": "Romania",
  "Rol": "Role",
  "SMTP opgeslagen": "SMTP saved",
  "SMTP test mislukt": "SMTP test failed",
  "Saint Kitts en Nevis": "Saint Kitts and Nevis",
  "Saldo": "Balance",
  "Saldo te ontvangen": "Balance to receive",
  "Samenvatting": "Summary",
  "Sao Tomé en Principe": "Sao Tome and Principe",
  "Saoedi-Arabië": "Saudi Arabia",
  "Save your custom discount codes per shop here. They will appear next to the button above.": "Save your custom discount codes per shop here. They will appear next to the button above.",
  "Scan autopapieren (AI)": "Scan vehicle papers (AI)",
  "Scan deze code met \"Scannen\" om dit onderdeel direct terug te vinden.": "Scan this code with \"Scan\" to quickly find this part.",
  "Scan met je bankapp om": "Scan with your banking app to",
  "Scan onderdeel": "Scan part",
  "Scan papieren": "Scan papers",
  "Scan papieren (AI)": "Scan papers (AI)",
  "Scannen": "Scan",
  "Schade": "Damage",
  "Schadepunt": "Damage point",
  "Schadepunten / aandachtspunten": "Damage points / points of attention",
  "Search by make, model...": "Search by make, model...",
  "Search by part, make, model, OEM no...": "Search by part, make, model, OEM no...",
  "Search license plate, make or model...": "Search license plate, make or model...",
  "Seizoen": "Season",
  "Selecteer een bon.": "Select a receipt.",
  "Selecteer een klant.": "Select a customer.",
  "Selecteer een voertuig.": "Select a vehicle.",
  "Selecteer eerst een afspraak": "Select an appointment first",
  "Selecteer eerst een betaling": "Select a payment first",
  "Selecteer eerst een bon": "Select a receipt first",
  "Selecteer eerst een klant": "Select a customer first",
  "Selecteer minstens 1 koppeling": "Select at least 1 link",
  "Selecteer minstens 1 onderdeel": "Select at least 1 part",
  "Selectie wissen": "Clear selection",
  "Service & onderhoud": "Service & maintenance",
  "Servië": "Serbia",
  "Share via WhatsApp": "Share via WhatsApp",
  "Showroom": "Showroom",
  "Showroom niet gevonden.": "Showroom not found.",
  "Showroom — publieke link": "Showroom — public link",
  "Showroom-link automatisch onder advertenties zetten": "Automatically place showroom link under advertisements",
  "Showroom-link nu ook terug te vinden in Instellingen → Algemeen": "Showroom link now also available in Settings → General",
  "Showroom-stijl (kleuren, thema & banner)": "Showroom style (colors, theme & banner)",
  "Showroom-stijl opgeslagen": "Showroom style saved",
  "Sla eerst de afspraak op": "Save the appointment first",
  "Sla het onderdeel eerst op": "Save the part first",
  "Slapend": "Dormant",
  "Sleep de PDF erin — klaar in seconden": "Drag the PDF in — ready in seconds",
  "Sleep je diagnoserapport hierheen": "Drag your diagnostic report here",
  "Sleepbare kalender: versleep een afspraak naar een ander tijdslot": "Draggable calendar: drag an appointment to another time slot",
  "Sleutel instellen": "Set key",
  "Sleutel verwijderd": "Key removed",
  "Slimme onderdelen-invoer met AI": "Smart parts entry with AI",
  "Slimme suggesties": "Smart suggestions",
  "Sloop/demontage voor alle voertuigtypes: auto, scooter, motor, aanhanger, caravan en meer": "Scrapping/dismantling for all vehicle types: car, scooter, motorcycle, trailer, caravan and more",
  "Sloopauto gekoppeld": "Scrap vehicle linked",
  "Sloopauto markeren → automatisch een complete onderdelenlijst genereren": "Mark salvage vehicle → automatically generate a complete parts list",
  "Sloopauto markeren → automatisch een onderdelenlijst genereren": "Mark salvage vehicle → automatically generate a parts list",
  "Sloopauto verwijderen?": "Remove scrap vehicle?",
  "Sloopvoertuig bewerken": "Edit scrap vehicle",
  "Sloopvoertuig bijgewerkt": "Scrap vehicle updated",
  "Sloopvoertuig toegevoegd": "Scrap vehicle added",
  "Sloopvoertuig toevoegen": "Add Scrap Vehicle",
  "Sloopvoertuigen": "Scrap Vehicles",
  "Sloopvoertuigen & beveiliging": "Scrap vehicles & security",
  "Sloopwaarde": "Scrap Value",
  "Slot-instellingen": "Lock Settings",
  "Slots automatisch berekend op jouw openingstijden": "Slots automatically calculated based on your opening hours",
  "Slovenië": "Slovenia",
  "Sluiten": "Close",
  "Snel verkopen": "Quick Sell",
  "Snel zoeken op kenteken, OEM, nummer, merk of model": "Quick search by license plate, OEM, number, make or model",
  "Snelle acties: klanten, bonnen, planning en RDW direct vanaf het dashboard": "Quick actions: customers, receipts, planning and RDW directly from the dashboard",
  "Snelle-verkoopprijs": "Quick Sale Price",
  "Som winstaandelen": "Sum of Profit Shares",
  "Somalië": "Somalia",
  "Sophie van den Berg": "Sophie van den Berg",
  "Sorteren": "Sort",
  "Specificaties": "Specifications",
  "Sta pop-ups toe om het kwitantie-document te openen": "Allow pop-ups to open the receipt document",
  "Staat": "Condition",
  "Staat live op je showroom": "Live on your showroom",
  "Standaard": "Default",
  "Standaard BTW%": "Default VAT%",
  "Standaard artikelcodes": "Default Item Codes",
  "Standaard hersteld": "Default Restored",
  "Standaardlijst": "Default List",
  "Standaardlijst hersteld": "Default List Restored",
  "Start": "Start",
  "Start werkorder": "Start Work Order",
  "Start with these 3 steps to set up your garage:": "Start with these 3 steps to set up your garage:",
  "Statistieken: bezoekers, meest bekeken, contactaanvragen, WhatsApp-kliks, verkocht": "Statistics: visitors, most viewed, contact requests, WhatsApp clicks, sold",
  "Status": "Status",
  "Status bijgewerkt": "Status Updated",
  "Status update mislukt": "Status Update Failed",
  "Stel automatische herinneringen in en bekijk verstuurde herinneringen": "Set up automatic reminders and view sent reminders",
  "Stel de categorie in voor alle geselecteerde onderdelen.": "Set the category for all selected parts.",
  "Stel de magazijnlocatie in voor alle geselecteerde onderdelen.": "Set the warehouse location for all selected parts.",
  "Stel een vraagprijs in": "Set an asking price",
  "Stel eerst je gratis Google Gemini API-sleutel in om de AI-functies te gebruiken.": "First, set up your free Google Gemini API key to use the AI features.",
  "Stel in wanneer klanten automatisch een herinnering ontvangen voor openstaande facturen": "Set when customers automatically receive a reminder for outstanding invoices",
  "Sterke punten": "Strengths",
  "Stijl": "Style",
  "Stijl opslaan": "Save Style",
  "Stop met handmatig BTW uitrekenen in Excel. Laat MonteurCentraal het zware werk doen.": "Stop manually calculating VAT in Excel. Let MonteurCentraal do the heavy lifting.",
  "Straat + nr": "Street + No.",
  "Streepjes-/QR-code scannen: naast de camera kun je nu ook een foto van de code uploaden (handig zonder webcam)": "Barcode/QR code scanning: in addition to using the camera, you can now also upload a photo of the code (useful without a webcam)",
  "Stukprijs": "Unit Price",
  "Stuur direct een complete back-up naar je gekoppelde cloud (Dropbox / Google Drive). Het bestand verschijnt in je": "Send a complete backup directly to your linked cloud (Dropbox / Google Drive). The file appears in your",
  "Stuur herinnering": "Send Reminder",
  "Stuur nu (Q": "Send Now (Q",
  "Subtotaal": "Subtotal",
  "Suggestieregels opgeslagen": "Suggestion Rules Saved",
  "Suggesties": "Suggestions",
  "Synchronisatie mislukt voor": "Synchronization failed for",
  "Synchroniseren...": "Synchronizing...",
  "Syrië": "Syria",
  "T.n.v.": "Attn.",
  "Taal": "Language",
  "Taal aanmaken": "Create Language",
  "Taal toevoegen": "Add Language",
  "Taal verwijderd": "Language Removed",
  "Taal verwijderen?": "Delete language?",
  "Taalcode (ISO 639-1)": "Language Code (ISO 639-1)",
  "Talen beheer": "Language Management",
  "Tarief": "Rate",
  "Te betalen aan Belastingdienst": "To be paid to Tax Authorities",
  "Te koop": "For sale",
  "Te laat (> 30 dagen)": "Overdue (> 30 days)",
  "Team / Medewerkers": "Team / Employees",
  "Teken hier uw handtekening": "Sign here",
  "Tekst": "Text",
  "Tekst gekopieerd": "Text copied",
  "Tekst opgeslagen": "Text saved",
  "Telefoon": "Phone",
  "Tenaamstelling": "Registration holder",
  "Tenaamstelling nieuwe eigenaar bij verkoop": "Registration of new owner upon sale",
  "Terug": "Back",
  "Terug naar MonteurCentraal": "Back to MonteurCentraal",
  "Terug naar dashboard": "Back to dashboard",
  "Terug naar de standaardlijst? Je eigen aanpassingen vervallen.": "Revert to default list? Your custom changes will be lost.",
  "Terug naar inloggen": "Back to login",
  "Terug op voorraad": "Back in stock",
  "Terug te ontvangen": "To be received back",
  "Terugbel": "Callback",
  "Terugbellen voor APK": "Call back for MOT",
  "Terugroepactie": "Recall",
  "Terugroepactie toegevoegd": "Recall added",
  "Terugroepactie toevoegen": "Add recall",
  "Terugroepactie verwijderen?": "Delete recall?",
  "Terugroepacties": "Recalls",
  "Terugroepacties / recalls registreren; het systeem markeert automatisch de getroffen voertuigen": "Register recalls; the system automatically marks affected vehicles",
  "Test verzenden": "Send test",
  "Testbericht verzonden naar": "Test message sent to",
  "Thank you for your trust in our garage!": "Thank you for your trust in our garage!",
  "Thema": "Theme",
  "Tijd": "Time",
  "Tijdelijk wachtwoord (min 6)": "Temporary password (min 6)",
  "Tijdinschatting per klus en werkstatus (wacht op onderdelen / bezig / klaar / opgehaald)": "Time estimate per job and work status (waiting for parts / in progress / complete / picked up)",
  "Tip-tekst": "Tip text",
  "Tip: Complete address + vehicle later via the Customers page.": "Tip: Complete address + vehicle later via the Customers page.",
  "Tip: No postal code? Enter street + house number and select city below (type \"Med\" for Medemblik). Then click \"Fill postal code via street + city\".": "Tip: No postal code? Enter street + house number and select city below (type \"Med\" for Medemblik). Then click \"Fill postal code via street + city\".",
  "Tip: Select a vehicle to search by make/model/year. Prices are shown live in the webshop (opens in a new tab).": "Tip: Select a vehicle to search by make/model/year. Prices are shown live in the webshop (opens in a new tab).",
  "Tip: gebruik rechtermuisklik op de lijst voor snelle auto-acties": "Tip: use right-click on the list for quick vehicle actions",
  "Tip: heb je geen postcode? Vul straat + huisnr in en kies plaats hieronder (typ \"Med\" voor Medemblik). Klik dan op \"Vul postcode via straat + plaats\".": "Tip: No postal code? Enter street + house number and select city below (type \"Med\" for Medemblik). Then click \"Fill postal code via street + city\".",
  "Tip: kies een voertuig zodat merk/model/bouwjaar wordt meegezocht. Prijzen worden live in de webshop getoond (openen in een nieuw tabblad).": "Tip: Select a vehicle to search by make/model/year. Prices are shown live in the webshop (opens in a new tab).",
  "Tip: laat een veld leeg om de Nederlandse fallback te gebruiken. Geel = nog niet opgeslagen.": "Tip: Leave a field blank to use the Dutch fallback. Yellow = not yet saved.",
  "Tip: sleep een afspraak naar een ander tijdslot om te verplaatsen.": "Tip: Drag an appointment to another time slot to move it.",
  "Tip: voeg foto's toe zodat de AI opties en schade automatisch herkent.": "Tip: add photos so AI automatically recognizes options and damage.",
  "Tip: voeg foto\\'s toe zodat de AI opties en schade automatisch herkent.": "Tip: Add photos so the AI automatically recognizes options and damage.",
  "Tip: vul later adres + voertuig aan via de Klanten pagina.": "Tip: Complete address + vehicle later via the Customers page.",
  "Titel": "Title",
  "Titel + tekst staan op je klembord; foto\\'s zijn gedownload. Plak ze in Facebook Marketplace.": "Title + text are on your clipboard; photos have been downloaded. Paste them into Facebook Marketplace.",
  "Titel en merk zijn verplicht": "Title and make are required",
  "Toegevoegd": "Added",
  "Toegevoegd aan \"Past op\"": "Added to \"Fits on\"",
  "Toekomstige + recente afspraken": "Future + recent appointments",
  "Toepassen": "Apply",
  "Toepassen op onderdeel": "Apply to part",
  "Toevoegen": "Add",
  "Toevoegen mislukt": "Failed to add",
  "Toon journaal": "Show journal",
  "Top verkochte voertuigen": "Top-selling vehicles",
  "Topklant dit jaar": "Top customer this year",
  "Totaal": "Total",
  "Totaal activa": "Total assets",
  "Totaal credit": "Total credit",
  "Totaal debet": "Total debit",
  "Totaal fooi": "Total tip",
  "Totaal incl. BTW": "Total incl. VAT",
  "Totaal indicatie (excl. BTW)": "Total estimated (excl. VAT)",
  "Totaal inkoopwaarde": "Total purchase value",
  "Totaal kosten (incl. BTW)": "Total costs (incl. VAT)",
  "Totaal kosten:": "Total costs:",
  "Totaal omzet": "Total revenue",
  "Totaal ontvangen": "Total received",
  "Totaal ontvangen betalingen": "Total payments received",
  "Totaal openstaand": "Total outstanding",
  "Totaal passiva": "Total liabilities",
  "Totale omzet": "Total revenue",
  "Totale omzet (lifetime)": "Total revenue (lifetime)",
  "Totale opbrengsten": "Total income",
  "Trefwoorden": "Keywords",
  "Trinidad en Tobago": "Trinidad and Tobago",
  "Tsjechië": "Czechia",
  "Tunesië": "Tunisia",
  "Typ +31, 0049, +44, of 06… — landcode wordt automatisch herkend na uit-tikken": "Type +31, 0049, +44, or 06… — country code will be automatically recognized after typing",
  "Typ eerst een onderdeel": "First type a part",
  "Typ nooit meer 3 keer dezelfde advertentie — verkoop je voorraad sneller.": "Never type the same ad 3 times again — sell your stock faster.",
  "Type": "Type",
  "Type (kras/deuk/roest)": "Type (scratch/dent/rust)",
  "Type document (Factuur / Offerte / Werkbon / Foto / Contract / etc):": "Document type (Invoice / Quote / Work order / Photo / Contract / etc):",
  "Type voertuig": "Vehicle type",
  "Uit": "Off",
  "Uitgebreider fotobeheer met hoofdfoto-keuze": "Enhanced photo management with main photo selection",
  "Uitleg in begrijpelijke taal voor jouw klant": "Explanation in understandable language for your customer",
  "Uitnodigen": "Invite",
  "Uitschakelen": "Disable",
  "Uitvoering": "Version",
  "Upgrade naar PRO": "Upgrade to PRO",
  "Upgrade naar PRO of ENTERPRISE voor onbeperkt gebruik + cloud sync.": "Upgrade to PRO or ENTERPRISE for unlimited use + cloud sync.",
  "Upload": "Upload",
  "Upload een Autel-diagnoserapport en laat AI er direct een werkbon van maken — met uitleg in gewoon Nederlands.": "Upload an Autel diagnostic report and let AI instantly turn it into a work order — with explanations in plain Dutch.",
  "Upload een diagnoserapport (PDF) — AI maakt automatisch klant, voertuig en werkbon met uitleg": "Upload a diagnostic report (PDF) — AI automatically creates customer, vehicle and work order with explanation",
  "Upload een diagnoserapport (PDF) — AI maakt een voorstel dat je eerst controleert vóór het opslaan": "Upload a diagnostic report (PDF) — AI will generate a proposal that you can review before saving",
  "Upload een diagnoserapport (PDF) → AI maakt klant, voertuig en werkbon met uitleg": "Upload a diagnostic report (PDF) → AI creates customer, vehicle and work order with explanation",
  "Upload een eerder gedownload back-up bestand om je data terug te zetten.": "Upload a previously downloaded backup file to restore your data.",
  "Upload eerst minimaal één foto": "First upload at least one photo",
  "Upload foto van code": "Upload photo of code",
  "Upload logo": "Upload logo",
  "Upload mislukt": "Upload failed",
  "Uploaden": "Uploading",
  "Urenregel": "Hours line",
  "Uurtarief arbeid (€)": "Hourly labor rate (€)",
  "Uw naam": "Your name",
  "VERVALLEN": "EXPIRED",
  "VIN": "VIN",
  "VIN check": "VIN check",
  "VIN lookup mislukt": "VIN lookup failed",
  "Vast (€)": "Fixed (€)",
  "Vaste klant, brengt zijn vrouw's auto ook": "Regular customer, also brings his wife's car",
  "Veelgestelde vragen": "Frequently Asked Questions",
  "Verander een onleesbaar diagnoserapport in een actiegerichte werkbon — zonder typewerk.": "Turn an unreadable diagnostic report into an actionable work order — without typing.",
  "Verander je wachtwoord direct zonder e-mail reset.": "Change your password directly without email reset.",
  "Verander je wachtwoord direct zonder e-mail reset. Je blijft ingelogd op alle apparaten.": "Change your password directly without email reset. You'll remain logged in on all devices.",
  "Verberg journaal": "Hide journal",
  "Verbergen": "Hide",
  "Verbeterde beveiliging: versleutelde SMTP-wachtwoorden en strengere toegang": "Improved security: encrypted SMTP passwords and stricter access",
  "Verbeterpunten": "Points for improvement",
  "Verbind": "Connect",
  "Verbind je cloud-account om documenten en foto's automatisch op te slaan in jouw cloud-storage. Dit maakt multi-device toegang mogelijk.": "Connect your cloud account to automatically save documents and photos to your cloud storage. This enables multi-device access.",
  "Verbonden met": "Connected to",
  "Vergeet niet": "Don't forget",
  "Vergelijk in webshops": "Compare in webshops",
  "Vergelijk onderdeelprijzen in 4 webshops op basis van voertuig + onderdeel": "Compare part prices across 4 webshops based on vehicle + part",
  "Vergelijk op Marktplaats": "Compare on Marktplaats",
  "Vergelijk prijzen (Google)": "Compare prices (Google)",
  "Verklaar foutcode": "Explain error code",
  "Verkocht": "Sold",
  "Verkocht 28-06 aan dhr. Janssen": "Sold 28-06 to Mr. Janssen",
  "Verkocht deze maand": "Sold this month",
  "Verkocht op": "Sold on",
  "Verkocht!": "Sold!",
  "Verkoop": "Sales",
  "Verkoop & factuur": "Sales & Invoice",
  "Verkoopadvertentie": "Sales listing",
  "Verkoopadvertentie voor Marktplaats, AutoScout24 en Facebook in 4 stijlen": "Sales ad for Marktplaats, AutoScout24, and Facebook in 4 styles",
  "Verkoophistorie": "Sales history",
  "Verkoopkans": "Sales opportunity",
  "Verkoopprijs": "Selling price",
  "Verkoopprijs (€)": "Selling price (€)",
  "Verkoopscore, verwachte verkooptijd en concurrentie-indicatie": "Sales score, estimated selling time, and competition indication",
  "Verkooptijd": "Selling time",
  "Verleng / koop licentie →": "Extend / buy license →",
  "Verleng licentie →": "Extend license →",
  "Vermeld bij je betaling altijd dit kenmerk:": "Always include this reference with your payment:",
  "Vermeld het kenmerk": "Include the reference",
  "Verplaatsen mislukt": "Move failed",
  "Verrekend": "Settled",
  "Verschuldigde BTW (over omzet)": "VAT due (on sales)",
  "Versturen mislukt": "Sending failed",
  "Verstuur automatisch elk kwartaal het rapport van het afgelopen kwartaal": "Automatically send quarterly report for the previous quarter",
  "Verstuur automatisch herinneringen": "Automatically send reminders",
  "Verstuurd": "Sent",
  "Verstuurde herinneringen": "Sent reminders",
  "Vertalen": "Translate",
  "Vertalingen": "Translations",
  "Vertalingen laden...": "Loading translations...",
  "Vervaldatum": "Due date",
  "Vervangen": "Replace",
  "Vervangen onderdelen / kosten": "Replaced parts / costs",
  "Vervangen onderdelen / materialen": "Replaced parts / materials",
  "Verversen": "Refresh",
  "Verversen mislukt": "Refresh failed",
  "Verwachte marge": "Expected margin",
  "Verwachte waarde": "Expected value",
  "Verwachte winst": "Expected profit",
  "Verwerken mislukt": "Processing failed",
  "Verwijder": "Delete",
  "Verwijder kostenpost": "Delete cost item",
  "Verwijder uit showroom": "Remove from showroom",
  "Verwijderd": "Removed",
  "Verwijderd uit showroom": "Removed from showroom",
  "Verwijderen": "Delete",
  "Verwijderen mislukt": "Deletion failed",
  "Verwijderen uit showroom?": "Remove from showroom?",
  "Verzendkosten (€)": "Shipping costs (€)",
  "Via postcode": "By postcode",
  "Via straat": "Via street",
  "Via street": "Via street",
  "Views": "Views",
  "Vink aan wat je wilt aanmaken": "Check what you want to create",
  "Vlag": "Flag",
  "Vlag emoji": "Flag emoji",
  "Voeg een voertuig toe zónder kenteken: maak een foto van de autopapieren": "Add a vehicle WITHOUT a license plate: take a photo of the car papers",
  "Voeg eerst een leverancier toe onder Inkoop.": "First, add a supplier under Purchasing.",
  "Voeg eerst teamleden toe": "First, add team members",
  "Voeg foto's toe — de AI herkent de staat en kenmerken. Genereer opnieuw na het uploaden.": "Add photos — the AI recognizes condition and characteristics. Regenerate after uploading.",
  "Voeg foto\\'s toe — de AI herkent de staat en kenmerken. Genereer opnieuw na het uploaden.": "Add photos — the AI recognizes condition and features. Regenerate after uploading.",
  "Voeg merken/modellen toe waar dit onderdeel op past.": "Add makes/models this part fits.",
  "Voeg minstens 1 regel toe": "Add at least 1 line item",
  "Voeg onderdelen toe met de + knop.": "Add parts using the + button.",
  "Voeg regels toe via de knop hierboven.": "Add lines using the button above.",
  "Voeg regels toe via de knoppen hierboven.": "Add lines using the buttons above.",
  "Voeg zoveel talen toe als je wilt (Duits, Frans, Spaans, Pools, ...) en vertaal de UI zelf. Wijzigingen zijn direct zichtbaar zonder herladen.": "Add as many languages as you like (German, French, Spanish, Polish, ...) and translate the UI yourself. Changes are instantly visible without reloading.",
  "Voegt je showroom-link + onderstaande tekst toe aan AI-advertenties voor Facebook en Forum. Niet op Marktplaats — externe links zijn daar niet toegestaan.": "Adds your showroom link + the text below to AI ads for Facebook and Forum. Not on Marktplaats — external links are not allowed there.",
  "Voer de admin-sleutel in om bestellingen te beheren.": "Enter the admin key to manage orders.",
  "Voer een geldig e-mailadres in": "Enter a valid email address",
  "Voer een licentiekey in": "Enter a license key",
  "Voer je Gemini API-sleutel in": "Enter your Gemini API key",
  "Voertuig": "Vehicle",
  "Voertuig (optioneel)": "Vehicle (optional)",
  "Voertuig / APK": "Vehicle / MOT",
  "Voertuig gevonden": "Vehicle found",
  "Voertuig opgeslagen": "Vehicle saved",
  "Voertuig toevoegen": "Add vehicle",
  "Voertuig verwijderd": "Vehicle deleted",
  "Voertuig verwijderen?": "Delete vehicle?",
  "Voertuig vrijgesteld van APK": "Vehicle exempt from MOT",
  "Voertuigconditie": "Vehicle condition",
  "Voertuigen": "Vehicles",
  "Voertuiggegevens": "Vehicle details",
  "Voertuigtype": "Vehicle type",
  "Voertuigwaarschuwingen": "Vehicle warnings",
  "Voettekst": "Footer",
  "Volgende": "Next",
  "Volgende APK": "Next MOT",
  "Volgende beurt": "Next service",
  "Volgens onze administratie staat het volgende bedrag nog open:": "According to our records, the following amount is still outstanding:",
  "Volledig instelbare meertaligheid met AI-vertaling (Google Gemini) — vertaal de hele app naar elke taal": "Fully customizable multilingualism with AI translation (Google Gemini) — translate the entire app into any language",
  "Volledig mobiele weergave: schuif-menu (hamburger), overzichtelijke kaarten in plaats van brede tabellen en grote knoppen": "Full mobile view: slide-out menu (hamburger), clear cards instead of wide tables, and large buttons",
  "Volledig ontvangen — voorraad bijgewerkt": "Fully received — stock updated",
  "Volledige Engelse interface: schakel de hele app met één klik om naar het Engels — direct en vloeiend, zonder wachten": "Full English interface: switch the entire app to English with one click — instant and smooth, no waiting",
  "Voor altijd (geen vervaldatum)": "Forever (no expiry date)",
  "Voor de gegevens die een aangesloten garage in MonteurCentraal invoert (zoals klant- en voertuiggegevens) is de garage de verwerkingsverantwoordelijke en treedt MonteurCentraal op als verwerker. Wij verwerken die gegevens uitsluitend in opdracht van de garage en voor het leveren van de dienst. Voor de gegevens van de garage zelf (account, facturatie, licentie) zijn wij verwerkingsverantwoordelijke.": "For data entered by a connected garage in MonteurCentraal (such as customer and vehicle data), the garage is the data controller and MonteurCentraal acts as processor. We process this data solely on behalf of the garage and for the provision of the service. For the garage's own data (account, billing, license), we are the data controller.",
  "Voor hobbyisten / niet-BTW-plichtige sleutelaars. Alle nieuwe bonnen worden zonder BTW gemaakt, op de factuur staat \"Geen BTW van toepassing\". Schakel uit om weer normaal te factureren.": "For hobbyists / non-VAT registered mechanics. All new receipts are created without VAT, the invoice states \"No VAT applicable\". Disable to resume normal invoicing.",
  "Voor zover aansprakelijkheid wettelijk niet kan worden uitgesloten, is de totale aansprakelijkheid beperkt tot het laagste van het bedrag dat de klant gedurende de twaalf maanden voorafgaand aan de gebeurtenis heeft betaald of €500.": "To the extent liability cannot be excluded by law, total liability is limited to the lower of the amount paid by the customer during the twelve months prior to the event or €500.",
  "Voor- en achternaam": "First and last name",
  "Voorbelasting (over inkopen)": "Input VAT (on purchases)",
  "Voorgeschoten (open)": "Advanced (outstanding)",
  "Voorgeschoten bedrag": "Advanced amount",
  "Voorgeschoten door": "Advanced by",
  "Voorgestelde offerteregels": "Suggested quote lines",
  "Voorkeur voor afspraak in ochtend": "Preference for morning appointment",
  "Voorraad": "Stock",
  "Voorraad / Min": "Stock / Min",
  "Voorraad, inkoop- en verkoopprijzen": "Stock, purchase and sale prices",
  "Voorraad-alerts (onder minimum)": "Stock alerts (below minimum)",
  "Voorraadbeheer voor gebruikte & nieuwe onderdelen (onderdelenkaart + foto's)": "Inventory management for used & new parts (part card + photos)",
  "Voorraadwaarde": "Stock value",
  "Voorraadwaarde (inkoop)": "Stock value (purchase)",
  "Voorraadwaarde, verwachte waarde en verkochte onderdelen in één oogopslag": "Stock value, projected value, and sold parts at a glance",
  "Voorschot toegevoegd": "Advance added",
  "Voorschot verwijderen?": "Remove advance payment?",
  "Voorschotten": "Advance payments",
  "Voorstel": "Proposal",
  "Voortgezet gebruik van de dienst geldt als aanvaarding van de gewijzigde voorwaarden.": "Continued use of the service constitutes acceptance of the modified terms.",
  "Voorwaarden": "Terms",
  "Vorige": "Previous",
  "Vraag": "Question",
  "Vraagprijs": "Asking price",
  "Vraagprijs bijgewerkt": "Asking price updated",
  "Vraagprijs-meter": "Asking price meter",
  "Vragen over deze voorwaarden kunnen worden gestuurd naar": "Questions about these terms can be sent to",
  "Vrije regel": "Custom line",
  "Vrijwaringsbewijs aan koper / overschrijving": "Indemnity certificate to buyer / transfer of ownership",
  "Vrijwaringsbewijs ontvangen bij inkoop": "Indemnity certificate received upon purchase",
  "Vul beide wachtwoorden in": "Enter both passwords",
  "Vul de klantnaam in": "Enter the customer name",
  "Vul e-mail en wachtwoord (min 6) in": "Enter email and password (min 6)",
  "Vul een bedrag in": "Enter an amount",
  "Vul een code in": "Enter a code",
  "Vul een foutcode in en klik op \"Verklaar foutcode\" voor een AI-uitleg.": "Enter a fault code and click \"Explain fault code\" for an AI explanation.",
  "Vul een geldig IBAN in om de betaal-QR te genereren.": "Enter a valid IBAN to generate the payment QR.",
  "Vul een geldig bedrag (excl. BTW) in": "Enter a valid amount (excl. VAT)",
  "Vul een kenteken in": "Enter a license plate",
  "Vul een kenteken in en AI schrijft direct een verkoopklare advertentie — voor Marktplaats, AutoScout24 én Facebook.": "Enter a license plate and AI instantly writes a sales-ready ad — for Marktplaats, AutoScout24 AND Facebook.",
  "Vul een leverancier in": "Enter a supplier",
  "Vul een omschrijving in": "Enter a description",
  "Vul een onderdeel in en klik op \"Bepaal waarde\" voor een AI-schatting.": "Enter a part and click \"Determine value\" for an AI estimate.",
  "Vul een onderdeelnaam in": "Enter a part name",
  "Vul een titel in": "Enter a title",
  "Vul een voertuig in en kies een categorie.": "Enter a vehicle and choose a category.",
  "Vul eerst een kenteken in": "First, enter a license plate",
  "Vul eerst een onderdeelnaam in": "First, enter a part name",
  "Vul eerst een voertuig in (kenteken of merk)": "First, enter a vehicle (license plate or make)",
  "Vul eerst het chassisnummer in": "First, enter the chassis number",
  "Vul eerst het kenteken in": "First, enter the license plate",
  "Vul eerst kenteken in": "First, enter license plate",
  "Vul eerst postcode + huisnr in": "First, enter postcode + house number",
  "Vul eerst postcode en huisnummer in (huisnummer in adresveld)": "First, enter postcode and house number (house number in address field)",
  "Vul eerst straat + huisnr in (bv. \"Bagijnhof 33\")": "First, enter street + house number (e.g., \"Bagijnhof 33\")",
  "Vul eerst straat + huisnummer in (bv. \"Bagijnhof 33\")": "First, enter street + house number (e.g., \"Bagijnhof 33\")",
  "Vul huidig en nieuw wachtwoord in": "Enter current and new password",
  "Vul in hoeveel er in totaal ontvangen is. Gekoppelde artikelen worden verhoogd; vrije regels worden automatisch als nieuw voorraad-artikel aangemaakt.": "Enter the total amount received. Linked items will be increased; custom lines will be automatically created as new stock items.",
  "Vul in via postcode": "Fill in by postcode",
  "Vul je e-mail credentials in om facturen en herinneringen vanuit jouw eigen e-mailadres te versturen.": "Enter your email credentials to send invoices and reminders from your own email address.",
  "Vul je e-mail in": "Enter your email",
  "Vul je e-mailadres in": "Enter your email address",
  "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen.": "Enter your email address. We will send you a link to set a new password.",
  "Vul kenteken of merk in": "Enter license plate or make",
  "Vul lege keys automatisch via AI": "Automatically fill empty keys via AI",
  "Vul minimaal een foutcode in (bv. P0300)": "Enter at least one fault code (e.g., P0300)",
  "Vul minimaal kenteken of merk/model in": "Enter at least license plate or make/model",
  "Vul ook plaats in (autocomplete helpt)": "Also enter city (autocomplete helps)",
  "Vul plaats en straat in via postcode + huisnr": "Enter city and street via postcode + house number",
  "Vul postcode in via straat + huisnr + plaats": "Enter postcode via street + house number + city",
  "Vul postcode via straat + plaats": "Enter postcode via street + city",
  "Vul uw naam in.": "Enter your name.",
  "W-2025-0232 voor Ahmed El Amrani": "W-2025-0232 for Ahmed El Amrani",
  "WERKBON": "WORK ORDER",
  "WINST & VERLIES": "PROFIT & LOSS",
  "Waarde onderweg": "Value in transit",
  "Waardebepaling": "Valuation",
  "Waarschijnlijke oorzaken": "Probable causes",
  "Wacht op akkoord": "Waiting for approval",
  "Wacht op betaling": "Waiting for payment",
  "Wacht op onderdelen": "Waiting for parts",
  "Wachtwoord": "Password",
  "Wachtwoord gewijzigd": "Password changed",
  "Wachtwoord gewijzigd!": "Password changed!",
  "Wachtwoord herhalen": "Confirm password",
  "Wachtwoord minimaal 6 tekens": "Password: minimum 6 characters",
  "Wachtwoord opslaan": "Save password",
  "Wachtwoord resetten": "Reset password",
  "Wachtwoord vergeten?": "Forgot password?",
  "Wachtwoord wijzigen": "Change password",
  "Wachtwoorden komen niet overeen": "Passwords do not match",
  "Wanneer een bonregel een van de trefwoorden bevat, toont de bon-editor eenmalig een tip. Trefwoorden en suggesties scheid je met komma\\'s; álle trefwoorden moeten voorkomen.": "When a receipt line item contains one of the keywords, the receipt editor will show a one-time tip. Separate keywords and suggestions with commas; all keywords must be present.",
  "Wat garages over ons zeggen": "What garages say about us",
  "Wat gebeurt er met mijn gegevens?": "What happens to my data?",
  "Wat is er aan de auto gedaan?": "What work was done on the car?",
  "Wat is nieuw": "What's new",
  "Wat voor werk wil je inplannen?": "What kind of work do you want to schedule?",
  "Wat's nieuw": "What's new",
  "We bewaren gegevens niet langer dan nodig. Facturatiegegevens bewaren we conform de wettelijke fiscale bewaarplicht (7 jaar). Apparaatregistraties die 90 dagen niet zijn gebruikt worden automatisch verwijderd. Bij beëindiging van het account verwijderen of anonimiseren we persoonsgegevens binnen een redelijke termijn, behoudens wettelijke verplichtingen.": "We do not store data longer than necessary. Billing data is retained in accordance with legal fiscal retention requirements (7 years). Device registrations that have not been used for 90 days are automatically deleted. Upon termination of the account, we delete or anonymize personal data within a reasonable period, subject to legal obligations.",
  "We gebruiken alleen functionele opslag (zoals een lokale apparaat-id en je inlogsessie) die noodzakelijk is voor de werking van de applicatie. We gebruiken geen tracking- of advertentiecookies.": "We only use functional storage (such as a local device ID and your login session) that is necessary for the application to function. We do not use tracking or advertising cookies.",
  "We hebben de key ook gemaild naar": "We have also emailed the key to",
  "We hebben deze betaalinstructies ook naar je gemaild.": "We have also emailed these payment instructions to you.",
  "We hebben een activatielink gestuurd naar": "We have sent an activation link to",
  "We konden de betaling niet bevestigen. Check je e-mail of probeer opnieuw.": "We could not confirm the payment. Check your email or try again.",
  "We kunnen deze privacyverklaring aanpassen. De meest actuele versie vind je altijd op deze pagina.": "We may update this privacy statement. The most current version can always be found on this page.",
  "We nemen passende technische en organisatorische maatregelen, waaronder versleutelde wachtwoorden, toegangsbeperking per garage (multi-tenant isolatie) en versleutelde verbindingen (HTTPS).": "We take appropriate technical and organizational measures, including encrypted passwords, access restriction per garage (multi-tenant isolation), and encrypted connections (HTTPS).",
  "We take appropriate technical and organizational measures, including encrypted passwords, access restriction per garage (multi-tenant isolation), and encrypted connections (HTTPS).": "We take appropriate technical and organizational measures, including encrypted passwords, access restriction per garage (multi-tenant isolation), and encrypted connections (HTTPS).",
  "We tonen deze site in jouw taal — wijzig hier": "We show this site in your language — change here",
  "Webshop: pakketten bestellen, betalen (bank/PayPal) en automatische licentie-uitgifte": "Webshop: order packages, pay (bank/PayPal), and automatic license issuance",
  "Weekagenda": "Weekly schedule",
  "Weer inslaan": "Restock",
  "Welkom bij": "Welcome to",
  "Welkom bij MonteurCentraal!": "Welcome to MonteurCentraal!",
  "Welkom terug!": "Welcome back!",
  "Werkbon": "Work order",
  "Werkbon / Offerte / Factuur": "Work Order / Quote / Invoice",
  "Werkbon met alle foutcodes als regels — direct factureerbaar": "Work order with all fault codes as line items — directly billable",
  "Werkbon verwijderd": "Work order deleted",
  "Werkbon verwijderen?": "Delete work order?",
  "Werkdatum": "Work date",
  "Werkkaart: nieuwe bon bovenaan, open klant, nieuwe planning, open PDF": "Work card: new receipt at the top, open customer, new schedule, open PDF",
  "Werkorder": "Work order",
  "Werkorder niet gevonden of de link is verlopen.": "Work order not found or the link has expired.",
  "Werkorder opgeslagen": "Work order saved",
  "Werkplaatsplanning": "Workshop Planning",
  "Werkplaatsstatus": "Workshop status",
  "Werkplek / brug": "Workstation / lift",
  "Werkplek- & magazijnlocaties": "Workstation & warehouse locations",
  "Werkstatus": "Work status",
  "Werkt het op meerdere computers?": "Does it work on multiple computers?",
  "Werkt met Autel en andere OBD-diagnoserapporten": "Works with Autel and other OBD diagnostic reports",
  "Werkt ook met buitenlandse documenten (bv. Duitse Zulassungsbescheinigung)": "Also works with foreign documents (e.g., German Zulassungsbescheinigung)",
  "Werkt vlot op de werkvloer — alle pagina's (dashboard, planning, werkkaarten, klanten, voertuigen, onderdelen, handel, facturen) zijn responsive": "Works smoothly on the shop floor — all pages (dashboard, planning, work cards, customers, vehicles, parts, trade, invoices) are responsive",
  "Werkt voor álle voertuigtypes: auto, camper, caravan, aanhanger, scooter, brommer, motor, vrachtwagen, oldtimer": "Works for ALL vehicle types: car, camper, caravan, trailer, scooter, moped, motorcycle, truck, classic car",
  "Werkzaamheden": "Services",
  "Werkzaamheid": "Activity",
  "WhatsApp ons": "WhatsApp us",
  "Wie heeft voorgeschoten?": "Who paid upfront?",
  "Wij delen gegevens alleen met partijen die nodig zijn om de dienst te leveren:": "We only share data with parties necessary to provide the service:",
  "Wij verkopen je gegevens nooit aan derden.": "We never sell your data to third parties.",
  "Wij verzoeken u vriendelijk het openstaande bedrag te voldoen. Heeft u inmiddels betaald? Dan kunt u deze herinnering als niet verzonden beschouwen.": "Please settle the outstanding amount. If you have already paid, please disregard this reminder.",
  "Wijzig": "Edit",
  "Wijzigen mislukt": "Edit failed",
  "Wijzigingen niet opgeslagen": "Changes not saved",
  "Wil je de garage per e-mail op de hoogte stellen van de intrekking? OK = wel mailen, Annuleren = niet mailen": "Do you want to notify the garage by email about the cancellation? OK = send email, Cancel = do not send email",
  "Winst": "Profit",
  "Winst & Verlies": "Profit & Loss",
  "Winst%": "Profit %",
  "Winstaandeel": "Profit share",
  "Winstaandeel opgeslagen": "Profit share saved",
  "Winstaandeel per teamlid + voorgeschoten kosten": "Profit share per team member + advanced expenses",
  "Winstaandeel per teamlid en voorgeschoten kosten verrekenen": "Calculate profit share per team member and advanced expenses",
  "Winstberekening": "Profit calculation",
  "Winstverdeling per teamlid": "Profit distribution per team member",
  "Wis": "Clear",
  "Wis filters en probeer opnieuw": "Clear filters and try again",
  "Wissen": "Delete",
  "Wordt gebruikt op alle bonnen, facturen en offertes": "Used on all receipts, invoices, and quotes",
  "Workflow": "Workflow",
  "You have the right to access, rectify, erase, restrict, and port your personal data, and the right to object. Please contact us via": "You have the right to access, rectify, erase, restrict, and port your personal data, and the right to object. Please contact us via",
  "Zakelijk": "Business",
  "Zakelijke klant, factuur per maand": "Business customer, monthly invoice",
  "Zekerheid": "Security",
  "Zelfde merk": "Same brand",
  "Zet aan om je boekingspagina te activeren.": "Turn on to activate your booking page.",
  "Zet de status op \"Bevestigd\" en klik op Bevestiging om de klant te informeren.": "Set status to \"Confirmed\" and click \"Confirmation\" to inform the customer.",
  "Zet een klacht om in concrete offerteregels (arbeid + onderdelen)": "Convert a complaint into concrete quote lines (labor + parts)",
  "Zet op beginscherm": "Add to Home Screen",
  "Zichtbare schade": "Visible damage",
  "Zo goed als nieuw": "As good as new",
  "Zodra je betaling binnen is, ontvang je je licentiekey automatisch per e-mail op": "Once your payment is received, you will automatically receive your license key via email at",
  "Zoek": "Search",
  "Zoek artikel of code… (bijv. koppeling, olie)": "Search item or code... (e.g., clutch, oil)",
  "Zoek bij": "Search at",
  "Zoek claim...": "Search claim...",
  "Zoek code, omschrijving of locatie...": "Search code, description or location...",
  "Zoek door klanten, bonnen, kentekens en documenten": "Search customers, receipts, license plates, and documents",
  "Zoek in keys of vertalingen...": "Search keys or translations...",
  "Zoek kenteken, merk of model...": "Search license plate, make or model...",
  "Zoek kenteken/locatie/klant": "Search license plate/location/customer",
  "Zoek kenteken/merk/klant": "Search license plate/make/customer",
  "Zoek leverancier...": "Search supplier...",
  "Zoek op kenteken, klantnaam, bonnummer of plaats": "Search by license plate, customer name, receipt number, or location",
  "Zoek op merk, model...": "Search by make, model...",
  "Zoek op naam, OEM, nummer, merk…": "Search by name, OEM, number, brand...",
  "Zoek op naam, klant of kenteken...": "Search by name, customer or license plate...",
  "Zoek op naam, plaats, telefoon, kenteken...": "Search by name, city, phone, license plate...",
  "Zoek op nummer, klant, omschrijving, kenteken...": "Search by number, customer, description, license plate...",
  "Zoek op onderdeel, merk, model, OEM-nr...": "Search by part, make, model, OEM no...",
  "Zoek ordernr of leverancier...": "Search order no or supplier...",
  "Zoeken op kenteken, OEM, nummer, merk; voorraadwaarde & verkoophistorie": "Search by license plate, OEM, number, brand; stock value & sales history",
  "Zoeken op klant of e-mail...": "Search by customer or email...",
  "Zoeken op leverancier, omschrijving, factuurnr...": "Search by supplier, description, invoice no...",
  "Zoeken...": "Searching...",
  "Zoekopdracht": "Search query",
  "Zonder ingestelde sleutel werken de AI-knoppen niet.": "AI buttons won't work without a configured key.",
  "aandacht": "Attention",
  "actieve apparaten toe. Meld een ander apparaat af om op dit apparaat verder te werken.": "active devices. Log out another device to continue working on this one.",
  "actieve meldingen die aandacht vragen": "active notifications requiring attention",
  "afgekeurd": "Failed",
  "afspraken": "Appointments",
  "afspraken met een dubbele boeking (zelfde brug of monteur op hetzelfde moment). Controleer de capaciteit.": "Appointments with a double booking (same lift or mechanic at the same time). Check capacity.",
  "all current data in your garage will be replaced by the contents of the file.": "all current data in your garage will be replaced by the contents of the file.",
  "all current data in your garage will be replaced with the contents of the file.": "all current data in your garage will be replaced with the contents of the file.",
  "alle arbeid + onderdelen over alle bonnen": "all labor + parts across all receipts",
  "alle functies waarbij automatisch gegevens, teksten, berekeningen, analyses of herkenningen worden gegenereerd.": "all features where data, texts, calculations, analyses, or recognitions are automatically generated.",
  "alle huidige data in jouw garage wordt vervangen door de inhoud van het bestand.": "All current data in your garage will be replaced with the contents of the file.",
  "alleen als de garage zelf cloud back-up koppelt.": "only if the garage links cloud backup itself.",
  "alles + 25 medewerkers": "All + 25 employees",
  "als app voor sneller werken op je telefoon of pc.": "as an app for faster work on your phone or PC.",
  "apparaten": "Devices",
  "arbeid": "Labor",
  "artikelen": "Items",
  "auto": "Vehicle",
  "automatisch": "Automatic",
  "backup.auto.desc": "we automatically send a fresh backup to your cloud folder every 24 hours.",
  "backup.cloud.desc": "Send a complete backup directly to your linked cloud (Dropbox / Google Drive). The file will appear in your",
  "backup.cloud.licenseRequired": "License required. First activate a PRO or ENTERPRISE license with",
  "backup.cloud.linked": "Cloud linked:",
  "backup.cloud.notLinked": "No cloud linked yet. Go to",
  "backup.cloud.notLinked.suffix": "tab and link Dropbox or Google Drive.",
  "backup.download.desc": "Download a complete JSON snapshot of all data (customers, vehicles, receipts, schedule, stock, payments, etc.). Store this file in a safe place (Dropbox / Google Drive / external drive).",
  "backup.restore.desc": "Upload a previously downloaded backup file to restore your data.",
  "backup.restore.warning": "all current data in your garage will be replaced by the contents of the file.",
  "basis features": "Basic features",
  "bekend is, hebben we een reset-link verstuurd. De link is 2 uur geldig.": "is known, we have sent a reset link. The link is valid for 2 hours.",
  "bellen": "Call",
  "beschikbaar.": "available.",
  "bestelreferentie, e-mailadres, gekozen pakket.": "Order reference, email address, chosen package.",
  "betalingen": "Payments",
  "bewerken": "Edit",
  "bijv. remblokken voor": "e.g., front brake pads",
  "binnenkort": "Coming soon",
  "boekhouder@kantoor.nl": "accountant@office.nl",
  "bonnen": "Receipts",
  "bonnen in behandeling": "Pending receipts",
  "bv. 2e eigenaar, rookvrij, nieuwe winterbanden…": "e.g., 2nd owner, non-smoking, new winter tires…",
  "bv. Bagijnhof 33 of Kerkstraat 5": "e.g., Bagijnhof 33 or Kerkstraat 5",
  "bv. Bosch, Shell, verhuurder": "e.g., Bosch, Shell, rental company",
  "bv. Deutsch, Français, Español": "e.g., German, French, Spanish",
  "bv. Garage Janssen": "e.g., Garage Janssen",
  "bv. Jan / Garage": "e.g., Jan / Garage",
  "bv. Medemblik": "e.g., Medemblik",
  "bv. Onderdelen bij Kroymans gehaald": "e.g., Parts obtained from Kroymans",
  "bv. Remblokken vervangen": "e.g., Brake pads replaced",
  "bv. Remblokken voor + olieservice": "e.g., Front brake pads + oil service",
  "bv. Trillingen bij remmen, piepend geluid voorzijde": "e.g., Vibrations when braking, squealing sound at front",
  "bv. de, fr, es, pl": "e.g., de, fr, es, pl",
  "bv. kleine kras achterbumper, steenslag motorkap": "e.g., small scratch rear bumper, stone chips hood",
  "bv. volledig onderhoudsboekje, dealer onderhouden": "e.g., full service history, dealer maintained",
  "cloud sync + 5 medewerkers": "Cloud sync + 5 employees",
  "col.apk": "MOT",
  "col.kenteken": "License Plate",
  "col.km": "Mileage",
  "col.merk_model": "Make / Model",
  "common.type": "Type",
  "controleer de voorgestelde koppelingen": "Check the suggested connections",
  "cs-card padded": "cs-card padded",
  "dagen": "Days",
  "dagen geldig": "Days valid",
  "dagen open": "Days open",
  "dagen verlopen": "Days expired",
  "dash.quick_actions": "Quick Actions",
  "de aanbieder van de software en bijbehorende diensten.": "the provider of the software and associated services.",
  "de duur bepaalt automatisch de beschikbare tijdsloten": "Duration automatically determines available time slots",
  "de online software (SaaS), website, API’s, mobiele toepassingen, AI-functionaliteiten en overige diensten van MonteurCentraal.": "The online software (SaaS), website, APIs, mobile applications, AI functionalities, and other services of MonteurCentraal.",
  "de persoonlijke toegang tot de dienst.": "Personal access to the service.",
  "deel deze op je website, Google en social media": "Share this on your website, Google, and social media",
  "deze maand": "This month",
  "dgn": "days",
  "dit apparaat": "This device",
  "documenten in archief": "Documents in archive",
  "door": "By",
  "e.g. Jan de Vries": "e.g. Jan de Vries",
  "e.g., Garage Janssen": "e.g., Garage Janssen",
  "e.g., Jan / Garage": "e.g., Jan / Garage",
  "eenmalig": "One-time",
  "eenmalig, voor altijd": "One-time, forever",
  "en kies": "and choose",
  "en log in met je Google-account.": "and log in with your Google account.",
  "en niet 100%. Pas de aandelen aan zodat ze samen 100% vormen.": "and not 100%. Adjust the shares so they total 100%.",
  "exact zoals de PDF": "Exactly as the PDF",
  "facturen": "Invoices",
  "fooi": "Tip",
  "foto(\\'s) gedownload": "Photo(s) downloaded",
  "foto(\\'s) opgeslagen": "Photo(s) saved",
  "foutcode(s) gevonden": "Error code(s) found",
  "garage": "Garage",
  "garantie": "Warranty",
  "gebruik een": "Use a",
  "gebruiker": "User",
  "gebruikers": "Users",
  "geen": "None",
  "geen BTW": "No VAT",
  "geen e-mail": "No email",
  "geen e-mailadres": "No email address",
  "geen omschrijving": "No description",
  "geen regels": "No items",
  "geen vervaldatum": "No due date",
  "geen voorraadkoppeling": "No stock link",
  "gegevens die klanten invoeren bij online afspraken.": "Data customers enter for online appointments.",
  "gekopieerd": "Copied",
  "geselecteerd": "Selected",
  "getroffen voertuig(en) in je bestand": "Affected vehicle(s) in your records",
  "gevonden voor kenteken": "Found for license plate",
  "handig bij buitenlandse auto's": "Useful for foreign cars",
  "handig bij buitenlandse auto\\'s": "Useful for foreign cars",
  "handmatig": "Manual",
  "herinnering": "Reminder",
  "herinnering(en) verstuurd": "Reminder(s) sent",
  "het recht om de dienst te gebruiken binnen de grenzen van het gekozen pakket.": "The right to use the service within the limits of the chosen package.",
  "het systeem mailt klanten automatisch zodra een factuur vervalt": "The system automatically emails customers as soon as an invoice is due",
  "iedere natuurlijke persoon of rechtspersoon die gebruikmaakt van de dienst.": "Any natural person or legal entity who uses the service.",
  "in het opmerkingenveld van PayPal.": "In the comments field of PayPal.",
  "in wachtrij": "In queue",
  "incl.": "incl.",
  "inkoop + kosten": "Purchase + costs",
  "is op de hoogte gesteld.": "has been notified.",
  "jaar geldig": "Valid for a year",
  "jan de vries": "jan de vries",
  "kentekens en voertuiggegevens opvragen (openbare data).": "Retrieve license plate and vehicle data (public data).",
  "klant": "Customer",
  "klanten geregistreerd": "Customers registered",
  "klik op een kenteken voor volledige historie": "Click on a license plate for full history",
  "koppeling": "Link",
  "koppeling(en) verwerken": "Process link(s)",
  "kost": "Cost",
  "kosten": "Costs",
  "laatst actief": "Last active",
  "leeg": "Empty",
  "leveranciers": "Suppliers",
  "licentie is direct beschikbaar.": "License is immediately available.",
  "map.": "Folder.",
  "marge ÷ kostprijs": "Margin ÷ Cost price",
  "mary-jane van der berg": "mary-jane van der berg",
  "meldingen ververst": "Notifications refreshed",
  "mislukt": "Failed",
  "ml-auto h-4 w-4": "ml-auto h-4 w-4",
  "ml-auto text-xs tracking-widest opacity-60": "ml-auto text-xs tracking-widest opacity-60",
  "ml-auto text-xs tracking-widest text-muted-foreground": "ml-auto text-xs tracking-widest text-muted-foreground",
  "mt-auto flex flex-col gap-2 p-4": "mt-auto flex flex-col gap-2 p-4",
  "mx-auto flex w-full justify-center": "mx-auto flex w-full justify-center",
  "naam, contactgegevens, kenteken, voertuig- en reparatiegegevens.": "Name, contact details, license plate, vehicle and repair data.",
  "naam, e-mailadres, bedrijfsgegevens, inloggegevens (versleuteld).": "Name, email address, company details, login credentials (encrypted).",
  "nav.accounting": "Accounting",
  "nav.admaker": "Create Ad",
  "nav.ai": "AI",
  "nav.apk": "MOT & Maintenance",
  "nav.balance": "Balance Sheet",
  "nav.bankimport": "Bank Import",
  "nav.debtors": "Debtor Management",
  "nav.diagnose": "AI Diagnostics",
  "nav.expenses": "Costs / Purchase Invoices",
  "nav.faultcode": "AI Fault Code Explanation",
  "nav.ledger": "General Ledger",
  "nav.oh_ads": "Advertisements",
  "nav.oh_history": "Sales History",
  "nav.oh_new": "New Parts",
  "nav.oh_scrap": "Salvage Vehicles",
  "nav.oh_stock": "Inventory",
  "nav.oh_used": "Used Parts",
  "nav.oh_value": "Valuation",
  "nav.onlinebooking": "Online Appointments",
  "nav.partstrade": "Parts Trading",
  "nav.purchaseorders": "Purchase Orders",
  "nav.purchasing": "Purchasing",
  "nav.quoteassist": "AI Quote Assistant",
  "nav.reminders": "Automatic Reminders",
  "nav.showroom": "Showroom",
  "nav.suppliers": "Suppliers",
  "nav.tyrehotel": "Tire Storage",
  "nav.vatprofit": "VAT & Profit",
  "nav.warranty": "Warranty Claims",
  "nav.whatsnew": "What's New",
  "niet koppelen": "Do not link",
  "niet van toepassing voor aanhanger < 750kg, etc.": "Not applicable for trailers < 750kg, etc.",
  "nieuw(e) artikel(en) aangemaakt in voorraad": "New item(s) created in stock",
  "nieuwe journaalposten aangemaakt": "New journal entries created",
  "nog": "Remaining",
  "o.b.v. bedrag": "Based on amount",
  "o.b.v. nummer": "Based on number",
  "of": "Or",
  "of klik om een PDF te kiezen (max 15 MB)": "Or click to choose a PDF (max 15 MB)",
  "of typ kenteken": "Or type license plate",
  "om bijvoorbeeld een vervangen onderdeel of voorgeschoten kosten te registreren.": "To register, for example, a replaced part or advanced costs.",
  "onder minimum voorraad": "Below minimum stock",
  "onder vermelding van bonnummer": "referencing receipt number",
  "onderdelen": "Parts",
  "only if the garage links cloud backup itself.": "only if the garage links cloud backup itself.",
  "open": "Open",
  "open facturen": "Open invoices",
  "openstaand": "Outstanding",
  "optioneel": "Optional",
  "optioneel — wie heeft onderdelen/kosten betaald": "Optional — who paid for parts/costs",
  "orders": "Orders",
  "over arbeid": "On labor",
  "over te maken": "To be transferred",
  "pagina": "Page",
  "per": "Per",
  "poging": "Attempt",
  "posten": "Entries",
  "posten bijgewerkt": "Entries updated",
  "reeds voldaan": "Already paid",
  "regel(s)": "Line(s)",
  "regels": "Lines",
  "regels totaal": "Total lines",
  "relative w-full overflow-auto": "relative w-full overflow-auto",
  "repeat(auto-fill, minmax(150px, 1fr))": "repeat(auto-fill, minmax(150px, 1fr))",
  "repeat(auto-fill, minmax(190px, 1fr))": "repeat(auto-fill, minmax(190px, 1fr))",
  "repeat(auto-fit, minmax(160px, 1fr))": "repeat(auto-fit, minmax(160px, 1fr))",
  "repeat(auto-fit, minmax(180px, 1fr))": "repeat(auto-fit, minmax(180px, 1fr))",
  "repeat(auto-fit, minmax(220px, 1fr))": "repeat(auto-fit, minmax(220px, 1fr))",
  "repeat(auto-fit, minmax(230px, 1fr))": "repeat(auto-fit, minmax(230px, 1fr))",
  "repeat(auto-fit, minmax(248px, 1fr))": "repeat(auto-fit, minmax(248px, 1fr))",
  "repeat(auto-fit, minmax(260px, 1fr))": "repeat(auto-fit, minmax(260px, 1fr))",
  "repeat(auto-fit, minmax(280px, 1fr))": "repeat(auto-fit, minmax(280px, 1fr))",
  "repeat(auto-fit, minmax(92px, 1fr))": "repeat(auto-fit, minmax(92px, 1fr))",
  "resultaten gevonden": "Results found",
  "sets in opslag": "Sets in storage",
  "sleutels": "Keys",
  "tabblad en koppel Dropbox of Google Drive.": "tab and link Dropbox or Google Drive.",
  "te koop": "For Sale",
  "tik op": "Tap",
  "tonen": "Show",
  "totaal": "Total",
  "totaal ontvangen": "Total received",
  "transacties": "Transactions",
  "uur": "Hour",
  "uw garage": "Your garage",
  "verbergen": "Hide",
  "vergelijkbare": "Similar",
  "verkochte onderdelen": "Parts sold",
  "verlies": "Loss",
  "versturen van e-mails (afspraken, herinneringen, licenties).": "Sending emails (appointments, reminders, licenses).",
  "vervalt": "Expires",
  "verwijderen?": "Delete?",
  "views": "Views",
  "voor het draaien van de applicatie en database.": "for running the application and database.",
  "voorgeschoten door": "Advanced by",
  "waarvan fooi": "of which tip",
  "wij sturen elke 24u automatisch een verse back-up naar je cloud-map.": "We automatically send a fresh backup to your cloud folder every 24 hours.",
  "wijzigingen wachten op sync": "Changes pending sync",
  "winst": "Profit",
  "wisseltip(s)": "Tip(s)",
  "zien dezelfde data": "see the same data",
  "{count} meldingen geregenereerd": "{count} notifications regenerated",
  "— Geen / handmatig —": "— None / manual —",
  "•••••••• (nieuwe sleutel invoeren om te wijzigen)": "•••••••• (enter new key to change)",
  "← Terug naar prijzen": "← Back to pricing",
  "🌍 AI-vertalen: vertaal de hele advertentie naar 8 talen (NL/EN/DE/FR/PL/ES/IT/TR) — natuurlijk, geen letterlijke vertaling": "🌍 AI Translate: translate the entire ad into 8 languages (NL/EN/DE/FR/PL/ES/IT/TR) — natural, not literal translation",
  "🔥 Geen maandelijkse kosten ooit meer": "🔥 No monthly fees ever"
};
